<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('InvoiceInbound.title')}}</strong>
                <div class="float-right">


                  <!--<router-link :to="{ path: '/invoiceinbounds'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInbounds.title')}}</router-link>-->
                  <!--<span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('Document.new')}}</span>-->
                </div>
              </div>

              <div class="card-footer">
                <template v-if="Number(viewRole)!==0">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="doSave">
                    <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                  </button>
                  &nbsp;
                  <template v-if="wf_status_saved==='UPLOADING'">
                    <button type="button" class="btn btn-danger btn-sm" v-on:click="doDelete">
                      <i class="fa fa-ban"></i> {{$t('global.delete')}}
                    </button>
                  </template>
                  <!--&nbsp;-->
                  <!--<button type="submit" class="btn btn-warning btn-sm" v-on:click="saveAndFinalize()">-->
                  <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.saveAndFinalize')}}-->
                  <!--</button>-->
                  <!--<button type="reset" class="btn btn-danger btn-sm">-->
                  <!--<i class="fa fa-ban"></i> Reset-->
                  <!--</button>-->
                </template>

              </div>

              <div class="    fContent">
                <div class="card-body card-block ">
                  <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>

                  <!--<div class="row">-->
                  <!--<div class="col-12 col-md-12">-->
                  <!--<div class="d-table ">-->
                  <!--<div class="d-table-row">-->
                  <!--<div class="d-table-cell">-->
                  <!--<PdfMake :docDefinition="docDefinition" docName="deliverynote" btnClass="btn btn-success btn-sm"/>-->
                  <!--</div>-->
                  <!--&lt;!&ndash;<template v-if="false && data.id">&ndash;&gt;-->
                  <!--&lt;!&ndash;<div class="d-table-cell rowPrintButtonContainer ">&ndash;&gt;-->
                  <!--&lt;!&ndash;<button type="button" class="btn btn-success btn-smX" v-on:click="rowPrint()">&ndash;&gt;-->
                  <!--&lt;!&ndash;<i class="fa fa-print"></i> {{$t('global.rowPrint')}}&ndash;&gt;-->
                  <!--&lt;!&ndash;</button>&ndash;&gt;-->
                  <!--&lt;!&ndash;</div>&ndash;&gt;-->
                  <!--&lt;!&ndash;</template>&ndash;&gt;-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<br>-->

                  <div class="row">
                    <div class="col-12 col-md-12">
                      <!--<router-link v-if="Number(data.id_sell)>0" :to="{ path: '/selsellview/'+data.id_sell}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i>-->
                      <!--{{$t('global.linkToSell')}}-->
                      <!--</router-link>-->
                      <!--<template v-if="Number(data.id_sell)>0">&nbsp;</template>-->
                      <!--<router-link v-if="Number(data.id_buyer)>0" :to="{ path: '/selbuyeredit/'+data.id_buyer}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i>-->
                      <!--{{$t('global.linkToBuyer')}}-->
                      <!--</router-link>-->
                      <!--<template v-if="Number(data.id_buyer)>0">&nbsp;</template>-->
                      <!--<router-link v-if="Number(data.id_businesspartner)>0" :to="{ path: '/crmbusinesspartner/'+data.id_businesspartner}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i>-->
                      <!--{{$t('global.linkToBusinesspartner')}}-->
                      <!--</router-link>-->
                      <!--<template v-if="Number(data.id_businesspartner)>0">&nbsp;</template>-->
                      <!--<router-link v-if="Number(data.id_adminuser)>0" :to="{ path: '/useredit/'+data.id_adminuser}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i>-->
                      <!--{{$t('global.linkToWorker')}}-->
                      <!--</router-link>-->
                      <!--<template v-if="Number(data.id_adminuser)>0">&nbsp;</template>-->
                    </div>
                  </div>


                  <!--Identifier-->
                  <template v-if="!data.wf_status_saved || data.wf_status_saved === 'UPLOADING'">
                    <div class="row">
                      <div class="col-12">
                        <div class="row form-group">
                          <div class="col col-6"><label class=" form-control-label">{{ $t('Document.documentserialnumber') }}</label>
                          </div>
                          <div class="col col-6">
                            <InputText id="identifier" name="data.identifier" v-model="data.identifier" v-validate="'required'" hasToKeyboard="auto" value=""
                                       :title="$t('businesspartner.businesspartnername')"
                                       placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.identifier')"/>
                            <small class="form-text text-muted"></small>
                            <NavDataDiffDisplayer defaultclass="alert alert-danger" irrelevantCapitalized="true" v-if="hasnav" :value="data.identifier" dataKey="invoiceNumber"
                                                  :dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="data.wf_status_saved !== 'UPLOADING'">
                    <div class="row" v-if="data.identifier">
                      <div class="col-12">
                        <div class="row form-group" v-if="data.identifier">
                          <div class="col col-6"><label class=" form-control-label">{{ $t('Document.documentserialnumber') }}</label>
                          </div>
                          <div class="col col-6">
                            {{data.identifier}}
                          </div>
                        </div>
                        <hr>
                      </div>
                    </div>
                  </template>

                  {{data.wf_status_saved}}
                  <template v-if="!data.id">

                    <div class="row form-group">
                      <div class="col col-6"><label for="from_taxnumber" class=" form-control-label">{{ $t('global.issuer') }} - {{ $t('businesspartner.taxnumber') }} </label></div>
                      <div class="col col-6">
                        <table class="w100">
                          <tr>
                            <td class="w0">
                              <template v-if="hasnav===true">
                                <div class="input-group topminus2px">
                                  <div class="btn btn-primary" v-on:click="getQueryTaxpayer('from')"><i class="fa fa-eye-slash"></i></div>
                                </div>
                              </template>
                            </td>
                            <td class="w100">
                              <InputText
                                id="from_taxnumber" name="data.from_taxnumber" v-model="data.from_taxnumber" v-validate="" hasToKeyboard="auto" value=""
                                :title="$t('businesspartner.from_taxnumber')"
                                placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.from_taxnumber')"/>
                              <small class="form-text text-muted"></small>
                              <NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.from_taxnumber" dataKey="supplierTaxNumber"
                                                    :dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <template v-if="hasnav===true">
                      <div class="row form-group">
                        <div class="col col-6">
                          <!--<label for="name" class=" form-control-label">{{ $t('Document.from_businesspartnername') }} ({{ $t('validator.required') }})</label>-->
                        </div>
                        <div class="col col-6">{{data.from_name}}
                          <!--<InputText id="name" name="data.from_name" v-model="data.from_name" v-validate="''" hasToKeyboard="auto" value=""-->
                          <!--:title="$t('Document.from_businesspartnername')"-->
                          <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_name')" readonly="true" disabled="true" />-->
                          <!--<small class="form-text text-muted"></small>-->
                        </div>
                      </div>
                    </template>

                  </template>

                  <!--IDE KELL a partneradószám-->
                  <!--status-->
                  <!--<template v-if="!data || !data.id">-->
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-6"><label class=" form-control-label">{{ $t('InvoiceInbound.wf_status') }}</label>-->
                  <!--</div>-->
                  <!--<div class="col col-6">-->
                  <!--<select id="wf_status" v-model="data.wf_status" class="form-control mandatory w100" name="wf_status"-->
                  <!--disabled="true"-->
                  <!--readonly="true"-->
                  <!--&gt;-->
                  <!--<option value="UPLOADING">{{$t('InvoiceInbound.wf_statuses.UPLOADING')}}</option>-->
                  <!--&lt;!&ndash;<option v-for="(wf_status ,i) in wf_statuses" :value="wf_status.value">{{ $t('InvoiceInbound.wf_statuses.' + wf_status.value) }}&ndash;&gt;-->
                  <!--&lt;!&ndash;</option>&ndash;&gt;-->
                  <!--</select>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</template>-->


                  <template v-if="data && data.id">

                    <template>
                      <div class="row form-group">
                        <div class="col col-6"><label class=" form-control-label">{{ $t('InvoiceInbound.wf_status') }}</label>
                        </div>
                        <div class="col col-6">
                          <select id="wf_status" v-model="data.wf_status" class="form-control mandatory w100" name="wf_status"
                          >
                            <!--:disabled="data.wf_status_saved === 'REJECTED' || data.wf_status_saved === 'PAID'"-->
                            <!--:readonly="data.wf_status_saved === 'REJECTED' || data.wf_status_saved === 'PAID'"-->

                            <!--<option value="">{{$t('form.pleasechoose')}}</option>-->
                            <option v-for="(wf_status ,i) in wf_statuses" :value="wf_status.value">{{ $t('InvoiceInbound.wf_statuses.' + wf_status.value) }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </template>

                    <!--<table class="w100">-->
                    <!--<tr>-->
                    <!--<td class="w1" style="vertical-align:top; ">-->
                    <!--<div class="" style="width:200px; ">-->
                    <!--</div>-->

                    <!--</td>-->
                    <!--<td>-->

                    <!--</td>-->
                    <!--</tr>-->
                    <!--</table>-->


                    <div class="row form-group">
                      <div class="col col-4">
                        <ImageDisplayer classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'invoiceinbound'" :handlerSuccess="imageClickHadler"></ImageDisplayer>

                      </div>
                      <div class="col col-8">

                        <div class="col col-12">


                          <template v-if="data.wf_status_saved === 'UPLOADING'">

                            <div class="row">
                              <div class="col-12">

                                <div class="row form-group">
                                  <div class="col col col-6"><label for="name" class=" form-control-label">{{ $t('global.images') }}</label>
                                  </div>
                                  <div class="col col col-6">
                                    <FileUploader classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'invoiceinbound'" :handlerSuccess="fileUploadHadler"></FileUploader>
                                  </div>
                                  <div class="col col-12">
                                    <!--<ImageDisplayer classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'invoiceinbound'" :handlerSuccess="imageClickHadler"></ImageDisplayer>-->
                                  </div>
                                </div>

                              </div>
                            </div>
                            <!--<div class="row">-->
                              <!--<div class="col-12">-->
                                <!--<span v-for="image in images" class="image">{{image}}</span>-->

                              <!--</div>-->
                            <!--</div>-->
                          </template>

                          <hr>


                          <template v-if="Number(viewRole)!==0">
                            <div class="row">
                              <div class="col-6 font-size-smaller">
                                <template v-if="data.wf_status_saved === 'UPLOADING'">

                                  <template v-if="!businesspartnersearcher">
                                    <button type="submit" class="btn btn-primary btn-sm" v-on:click="businesspartnersearcherClick">
                                      <i class="fa fa-dot-circle-o"></i> {{$t('businesspartnersearcher.search')}}
                                    </button>
                                  </template>
                                  <template v-if="businesspartnersearcher">
                                    <button type="submit" class="btn btn-primary btn-sm" v-on:click="businesspartnersearcherClickClose">
                                      <i class="fa fa-close"></i> {{$t('businesspartnersearcher.close')}}
                                    </button>
                                  </template>
                                </template>

                              </div>
                              <div class="col-6 font-size-smaller">

                                <!--<template v-if="data.wf_status_saved === 'UPLOADING'">-->
                                <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="copyCompanyDataToModel">-->
                                <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.copy')}}-->
                                <!--</button>-->
                                <!--</template>-->

                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 font-size-smaller">
                                <template v-if="businesspartnersearcher">
                                  <BusinessPartnerSearcher></BusinessPartnerSearcher>
                                </template>
                              </div>
                            </div>
                          </template>


                          <!--Ez csak a nem szerkesztésnél kell-->
                          <template v-if="data.wf_status_saved !== 'UPLOADING'">

                            <div class="row">
                              <div class="col-12 col-md-6">
                                <div class="row form-group">
                                  <div class="col col-md-3"><label class=" form-control-label"><span class="font-weight-bold">{{ $t('global.issuer') }}</span></label>
                                  </div>
                                  <div class="col-12 col-md-9"></div>
                                </div>
                              </div>
                              <div class="col-12 col-md-6">
                                <div class="row form-group">
                                  <div class="col col-md-3"><label class=" form-control-label"><span class="font-weight-bold">{{ $t('global.buyer') }}</span></label>
                                  </div>
                                  <div class="col-12 col-md-9"></div>
                                </div>
                              </div>
                            </div>
                            <hr>
                            <div class="row">
                              <div class="col col-6">
                                <div class="row">

                                  <div class="col col-12">

                                    {{data.from_name}}<br>
                                    {{data.from_taxnumber}}<br>
                                    <template v-if="data.from_taxnumbercountrygroup">{{data.from_taxnumbercountrygroup}}<br></template>
                                    <template v-if="data.from_taxnumberother">{{data.from_taxnumberother}}<br></template>
                                    <template v-if="data.from_registrationnumber">{{data.from_registrationnumber}}<br></template>

                                    {{data.from_bank_account}}<br>
                                    {{data.from_zip}}<span v-if="data.from_zip&&data.from_city">,</span>
                                    {{data.from_city}}
                                    {{data.from_public_space}}
                                    {{data.from_nature_of_public_space}}
                                    {{data.from_house_number}}

                                    <br>
                                  </div>


                                </div>
                              </div>
                              <div class="col col-6">
                                <div class="row">
                                  <div class="col col-12">

                                    {{data.to_name}}<br>
                                    {{data.to_taxnumber}}<br>
                                    <template v-if="data.to_taxnumbercountrygroup">{{data.to_taxnumbercountrygroup}}<br></template>
                                    <template v-if="data.to_taxnumberother">{{data.to_taxnumberother}}<br></template>
                                    <template v-if="data.to_registrationnumber">{{data.to_registrationnumber}}<br></template>

                                    {{data.to_bank_account}}<br>
                                    {{data.to_zip}}<span v-if="data.to_zip&&data.to_city">,</span>
                                    {{data.to_city}}
                                    {{data.to_public_space}}
                                    {{data.to_nature_of_public_space}}
                                    {{data.to_house_number}}
                                    <br>
                                  </div>

                                </div>
                              </div>
                            </div>
                            <hr>
                          </template>


                          <template v-if="data.wf_status_saved === 'UPLOADING'">


                            <div class="row">


                              <template v-if="true && viewRole!==0">
                                <div class="col-12 col-sm-12col-md-12col-lg-6">

                                  <div class="row form-group">
                                    <div class="col-12">
                                      <label class=" form-control-label"><span class="font-weight-bold">{{ $t('global.issuer') }}</span></label>
                                    </div>
                                  </div>

                                  <div class="row form-group">
                                    <div class="col col-md-3"><label for="name" class=" form-control-label">{{ $t('Document.from_businesspartnername') }} ({{ $t('validator.required') }})</label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                      <InputText id="name" name="data.from_name" v-model="data.from_name" v-validate="'required'" hasToKeyboard="auto" value=""
                                                 :title="$t('Document.from_businesspartnername')"
                                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_name')"/>
                                      <small class="form-text text-muted"></small>
                                      <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.from_name" dataKey="from_name"
                                                            :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                    </div>
                                  </div>

                                  <div class="row form-group">
                                    <div class="col col-md-3"><label for="from_taxnumber1" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} </label></div>
                                    <div class="col-12 col-md-9">
                                      <table class="w100">
                                        <tr>
                                          <td class="w0">
                                            <template v-if="hasnav===true">
                                              <div class="input-group topminus2px">
                                                <div class="btn btn-primary" v-on:click="getQueryTaxpayer('from')"><i class="fa fa-eye-slash"></i></div>
                                              </div>
                                            </template>
                                          </td>
                                          <td class="w100">
                                            <InputText
                                              id="from_taxnumber1" name="data.from_taxnumber" v-model="data.from_taxnumber" v-validate="" hasToKeyboard="auto" value=""
                                              :title="$t('businesspartner.from_taxnumber')"
                                              placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.from_taxnumber')"/>
                                            <small class="form-text text-muted"></small>
                                            <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.from_taxnumber" dataKey="supplierTaxNumber"-->
                                            <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                                            <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.from_taxnumber" dataKey="from_taxnumber"
                                                                  :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>


                                  <div class="row form-group">
                                    <div class="col-12 text-right">
                                      <button type="submit" class="btn btn-warning btn-sm" v-on:click="openIssuerHandler">
                                        <template v-if="openIssuer"><i class="fa fa-chevron-left"></i></template>
                                        <template v-if="!openIssuer"><i class="fa fa-chevron-down"></i></template>
                                        {{$t('InvoiceInbound.openIssuer')}}
                                      </button>
                                    </div>
                                  </div>

                                  <template v-if="openIssuer">

                                    <!--<div class="row form-group">-->
                                    <!--<div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} </label></div>-->
                                    <!--<div class="col-12 col-md-9">-->
                                    <!--<InputText id="taxnumber" name="data.from_taxnumber" v-model="data.from_taxnumber" v-validate="''" hasToKeyboard="auto" value=""-->
                                    <!--:title="$t('businesspartner.taxnumber')"-->
                                    <!--placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.from_taxnumber')"/>-->
                                    <!--<small class="form-text text-muted"></small>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_taxnumbercountrygroup" class=" form-control-label">{{ $t('businesspartner.taxnumbercountrygroup') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_taxnumbercountrygroup" name="data.from_taxnumbercountrygroup" v-model="data.from_taxnumbercountrygroup" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.taxnumbercountrygroup')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_taxnumbercountrygroup')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_taxnumberother" class=" form-control-label">{{ $t('businesspartner.taxnumberother') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_taxnumberother" name="data.from_taxnumberother" v-model="data.from_taxnumberother" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.taxnumberother')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_taxnumberother')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_registrationnumber" class=" form-control-label">{{ $t('businesspartner.registrationnumber') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_registrationnumber" name="data.from_registrationnumber" v-model="data.from_registrationnumber" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.registrationnumber')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_registrationnumber')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_bank_account" class=" form-control-label">{{ $t('businesspartner.bank_account') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_bank_account" name="data.from_bank_account" v-model="data.from_bank_account" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.bank_account')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_bank_account')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_zip" class=" form-control-label">{{ $t('businesspartner.zip') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_zip" name="data.from_zip" v-model="data.from_zip" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.zip')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.from_zip')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_city" class=" form-control-label">{{ $t('businesspartner.city') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_city" name="data.from_city" v-model="data.from_city" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.city')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_city')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_public_space" class=" form-control-label">{{ $t('businesspartner.public_space') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_public_space" name="data.from_public_space" v-model="data.from_public_space" v-validate="'required'" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.public_space')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_public_space')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_nature_of_public_space" class=" form-control-label">{{ $t('businesspartner.nature_of_public_space') }} ({{ $t('validator.required')
                                        }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_nature_of_public_space" name="data.from_nature_of_public_space" v-model="data.from_nature_of_public_space" v-validate="'required'" hasToKeyboard="auto"
                                                   value=""
                                                   :title="$t('businesspartner.nature_of_public_space')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_nature_of_public_space')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_house_number" class=" form-control-label">{{ $t('businesspartner.house_number') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_house_number" name="data.from_house_number" v-model="data.from_house_number" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.house_number')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.from_house_number')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_building" class=" form-control-label">{{ $t('businesspartner.building') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_building" name="data.from_building" v-model="data.from_building" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.building')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.from_building')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_staircase" class=" form-control-label">{{ $t('businesspartner.staircase') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_staircase" name="data.from_staircase" v-model="data.from_staircase" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.staircase')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_staircase')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_floor" class=" form-control-label">{{ $t('businesspartner.floor') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_floor" name="data.from_floor" v-model="data.from_floor" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.floor')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.from_floor')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_door" class=" form-control-label">{{ $t('businesspartner.door') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_door" name="data.from_door" v-model="data.from_door" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.door')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.from_door')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_county" class=" form-control-label">{{ $t('businesspartner.county') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_county" name="data.from_county" v-model="data.from_county" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.county')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_county')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_country" class=" form-control-label">{{ $t('businesspartner.country') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_country" name="data.from_country" v-model="data.from_country" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.country')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_country')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_email_def" class=" form-control-label">{{ $t('businesspartner.email_def') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_email_def" name="data.from_email_def" v-model="data.from_email_def" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.email_def')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_email_def')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_phone_def" class=" form-control-label">{{ $t('businesspartner.phone_def') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_phone_def" name="data.from_phone_def" v-model="data.from_phone_def" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.phone_def')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_phone_def')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="from_lot_number" class=" form-control-label">{{ $t('businesspartner.lot_number') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="from_lot_number" name="data.from_lot_number" v-model="data.from_lot_number" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.from_lot_number')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.from_lot_number')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>


                                  </template>
                                </div>
                              </template>


                              <template v-if="true && viewRole!==0">
                                <div class="col-12 col-sm-12col-md-12col-lg-6">
                                  <hr>

                                  <div class="row form-group">
                                    <div class="col-8">
                                      <label class=" form-control-label"><span class="font-weight-bold">{{ $t('global.buyer') }}</span></label>
                                    </div>

                                    <div class="col-4 text-right">
                                      <template v-if="data.wf_status_saved === 'UPLOADING'">
                                        <button type="submit" class="btn btn-primary btn-sm" v-on:click="copyCompanyDataToModel">
                                          <i class="fa fa-dot-circle-o"></i> {{$t('global.copy')}}
                                        </button>
                                      </template>
                                    </div>

                                  </div>
                                  <div class="row form-group">
                                    <div class="col col-md-3"><label for="to_name" class=" form-control-label">{{ $t('businesspartner.businesspartnername') }} ({{ $t('validator.required')
                                      }})</label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                      <InputText id="to_name" name="data.to_name" v-model="data.to_name" v-validate="'required'" hasToKeyboard="auto" value=""
                                                 :title="$t('businesspartner.businesspartnername')"
                                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_name')"/>
                                      <small class="form-text text-muted"></small>
                                      <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.to_name" dataKey="to_name"
                                                            :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                    </div>
                                  </div>


                                  <div class="row form-group">
                                    <div class="col col-md-3"><label for="to_taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} </label></div>
                                    <div class="col-12 col-md-9">
                                      <table class="w100">
                                        <tr>
                                          <td class="w0">
                                            <template v-if="hasnav===true">
                                              <div class="input-group topminus2px">
                                                <div class="btn btn-primary" v-on:click="getQueryTaxpayer('to')"><i class="fa fa-eye-slash"></i></div>
                                              </div>
                                            </template>
                                          </td>
                                          <td class="w100">
                                            <InputText
                                              id="to_taxnumber" name="data.to_taxnumber" v-model="data.to_taxnumber" v-validate="" hasToKeyboard="auto" value=""
                                              :title="$t('businesspartner.to_taxnumber')"
                                              placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.to_taxnumber')"/>
                                            <small class="form-text text-muted"></small>
                                          </td>
                                        </tr>
                                      </table>
                                      <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.to_taxnumber" dataKey="to_taxnumber"
                                                            :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                    </div>
                                  </div>

                                  <div class="row form-group">
                                    <div class="col-12 text-right">
                                      <button type="submit" class="btn btn-warning btn-sm" v-on:click="openBuyerHandler">
                                        <template v-if="openBuyer"><i class="fa fa-chevron-left"></i></template>
                                        <template v-if="!openBuyer"><i class="fa fa-chevron-down"></i></template>
                                        {{$t('InvoiceInbound.openBuyer')}}
                                      </button>
                                    </div>
                                  </div>

                                  <template v-if="openBuyer">

                                    <!--<div class="row form-group">-->
                                    <!--<div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} </label></div>-->
                                    <!--<div class="col-12 col-md-9">-->
                                    <!--<InputText id="to_taxnumber" name="data.to_taxnumber" v-model="data.to_taxnumber" v-validate="''" hasToKeyboard="auto" value=""-->
                                    <!--:title="$t('businesspartner.taxnumber')"-->
                                    <!--placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.to_taxnumber')"/>-->
                                    <!--<small class="form-text text-muted"></small>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_taxnumbercountrygroup" class=" form-control-label">{{ $t('businesspartner.taxnumbercountrygroup') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_taxnumbercountrygroup" name="data.to_taxnumbercountrygroup" v-model="data.to_taxnumbercountrygroup" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.taxnumbercountrygroup')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_taxnumbercountrygroup')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_taxnumberother" class=" form-control-label">{{ $t('businesspartner.taxnumberother') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_taxnumberother" name="data.to_taxnumberother" v-model="data.to_taxnumberother" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.taxnumberother')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_taxnumberother')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_registrationnumber" class=" form-control-label">{{ $t('businesspartner.registrationnumber') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_registrationnumber" name="data.to_registrationnumber" v-model="data.to_registrationnumber" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.registrationnumber')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_registrationnumber')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_bank_account" class=" form-control-label">{{ $t('businesspartner.bank_account') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_bank_account" name="data.to_bank_account" v-model="data.to_bank_account" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.bank_account')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_bank_account')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_zip" class=" form-control-label">{{ $t('businesspartner.zip') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_zip" name="data.to_zip" v-model="data.to_zip" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.zip')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.to_zip')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_city" class=" form-control-label">{{ $t('businesspartner.city') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_city" name="data.to_city" v-model="data.to_city" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.city')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_city')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_public_space" class=" form-control-label">{{ $t('businesspartner.public_space') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_public_space" name="data.to_public_space" v-model="data.to_public_space" v-validate="'required'" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.public_space')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_public_space')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_nature_of_public_space" class=" form-control-label">{{ $t('businesspartner.nature_of_public_space') }} ({{ $t('validator.required')
                                        }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_nature_of_public_space" name="data.to_nature_of_public_space" v-model="data.to_nature_of_public_space" v-validate="'required'" hasToKeyboard="auto"
                                                   value=""
                                                   :title="$t('businesspartner.nature_of_public_space')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_nature_of_public_space')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_house_number" class=" form-control-label">{{ $t('businesspartner.house_number') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_house_number" name="data.to_house_number" v-model="data.to_house_number" v-validate="''" hasToKeyboard="auto" value=""
                                                   :title="$t('businesspartner.house_number')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.to_house_number')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_building" class=" form-control-label">{{ $t('businesspartner.building') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_building" name="data.to_building" v-model="data.to_building" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.building')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.to_building')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_staircase" class=" form-control-label">{{ $t('businesspartner.staircase') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_staircase" name="data.to_staircase" v-model="data.to_staircase" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.staircase')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_staircase')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_floor" class=" form-control-label">{{ $t('businesspartner.floor') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_floor" name="data.to_floor" v-model="data.to_floor" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.floor')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.to_floor')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_door" class=" form-control-label">{{ $t('businesspartner.door') }}</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_door" name="data.to_door" v-model="data.to_door" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.door')"
                                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.to_door')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_county" class=" form-control-label">{{ $t('businesspartner.county') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_county" name="data.to_county" v-model="data.to_county" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.county')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_county')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_country" class=" form-control-label">{{ $t('businesspartner.country') }} ({{ $t('validator.required') }})</label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_country" name="data.to_country" v-model="data.to_country" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.country')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_country')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_email_def" class=" form-control-label">{{ $t('businesspartner.email_def') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_email_def" name="data.to_email_def" v-model="data.to_email_def" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.email_def')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_email_def')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_phone_def" class=" form-control-label">{{ $t('businesspartner.phone_def') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_phone_def" name="data.to_phone_def" v-model="data.to_phone_def" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.phone_def')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_phone_def')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                    <div class="row form-group">
                                      <div class="col col-md-3"><label for="to_lot_number" class=" form-control-label">{{ $t('businesspartner.lot_number') }} </label></div>
                                      <div class="col-12 col-md-9">
                                        <InputText id="to_lot_number" name="data.to_lot_number" v-model="data.to_lot_number" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.to_lot_number')"
                                                   placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_lot_number')"/>
                                        <small class="form-text text-muted"></small>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </template>


                            </div>
                          </template>

                          <hr>

                          <div class="row form-group">
                            <div class="col col-md-3"><label for="payment_type" class=" form-control-label">{{ $t('Document.payment_type') }} ({{ $t('validator.required')
                              }})</label>
                            </div>
                            <div class="col-12 col-md-9">
                              <select id="payment_type" name="data.payment_type" v-model="data.payment_type" v-validate="'required'"
                                      :title="$t('Document.payment_type')"
                                      class="form-control mandatory" :hasError="errors.has('data.payment_type')"
                                      :disabled="(data.wf_status_saved !== 'UPLOADING')"
                                      :readonly="(data.wf_status_saved !== 'UPLOADING')"
                              >
                                <option value="1">{{$t('Document.paymenttype1')}}</option>
                                <option value="2">{{$t('Document.paymenttype2')}}</option>
                                <option value="3">{{$t('Document.paymenttype3')}}</option>
                              </select>
                              <small class="form-text text-muted"></small>
                              <div class="alert alert-warning" role="alert"
                                   v-if="(!data.payment_type || (data.payment_type === '1' || data.payment_type === '2')) && (data.dt_completion!==data.dt_paymentdeadline||data.dt_paymentdeadline!==data.dt_make||data.dt_completion!==data.dt_make)">
                                {{$t('NavDataDiffDisplayer.presumedtotransfer')}}
                              </div>
                              <div class="alert alert-warning" role="alert"
                                   v-if="(!data.payment_type || data.payment_type === '3') && (data.dt_completion===data.dt_paymentdeadline&&data.dt_paymentdeadline===data.dt_make&&data.dt_completion===data.dt_make)">
                                {{$t('NavDataDiffDisplayer.presumedtocachecard')}}
                              </div>
                              <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.payment_type" dataKey="payment_type"
                                                    :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                            </div>
                          </div>

                          <div class="row form-group">
                            <div class="col col-md-3"><label for="dt_completion" class=" form-control-label">{{ $t('Document.dt_completion') }} ({{ $t('validator.required')
                              }})</label>
                            </div>
                            <div class="col-12 col-md-9">
                              <InputText type="DatetimepickerBp"
                                         id="dt_completion" name="data.dt_completion" v-model="data.dt_completion" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:false}" hasToKeyboard="auto" value=""
                                         :title="$t('Document.dt_completion')"
                                         placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_completion')"
                                         :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                         :readonly="String(data.wf_status_saved !== 'UPLOADING')"
                              />
                              <small class="form-text text-muted"></small>
                              <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_completion" dataKey="invoiceDeliveryDate"-->
                              <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                              <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_completion" dataKey="dt_completion"
                                                    :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                            </div>
                          </div>
                          <div class="row form-group">
                            <div class="col col-md-3"><label for="dt_make" class=" form-control-label">{{ $t('Document.dt_make') }} ({{ $t('validator.required')
                              }})</label>
                            </div>
                            <div class="col-12 col-md-9">
                              <InputText type="DatetimepickerBp"
                                         id="dt_make" name="data.dt_make" v-model="data.dt_make" v-validate="{date_format:'yyyy-MM-dd', required:true}" hasToKeyboard="auto" value=""
                                         :title="$t('Document.dt_make')"
                                         placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_make')"
                                         :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                         :readonly="String(data.wf_status_saved !== 'UPLOADING')"
                              />
                              <small class="form-text text-muted"></small>
                              <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_make" dataKey="invoiceIssueDate" :dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                              <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_make" dataKey="dt_make"
                                                    :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                            </div>
                          </div>
                          <div class="row form-group">
                            <div class="col col-md-3"><label for="dt_paymentdeadline" class=" form-control-label">{{ $t('Document.dt_paymentdeadline') }} ({{ $t('validator.required')
                              }})</label>
                            </div>
                            <div class="col-12 col-md-9">
                              <InputText type="DatetimepickerBp"
                                         id="dt_paymentdeadline" name="data.dt_paymentdeadline" v-model="data.dt_paymentdeadline" v-validate="{date_format:'yyyy-MM-dd', required:true}" hasToKeyboard="auto" value=""
                                         :title="$t('Document.dt_paymentdeadline')"
                                         placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_paymentdeadline')"
                                         :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                         :readonly="String(data.wf_status_saved !== 'UPLOADING')"
                              />
                              <small class="form-text text-muted"></small>
                              <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_paymentdeadline" dataKey="paymentDate"-->
                              <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                              <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_paymentdeadline" dataKey="dt_paymentdeadline"
                                                    :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                            </div>
                          </div>


                          <template v-if="data.wf_status_saved !== 'UPLOADING' ">

                            <div class="row form-group">
                              <div class="col col-md-3"><label for="dt_needtransfer" class=" form-control-label">{{ $t('InvoiceInbound.dt_needtransfer') }} ({{ $t('validator.required')
                                }})</label>
                              </div>
                              <div class="col-12 col-md-9">
                                <InputText type="DatetimepickerBp"
                                           id="dt_needtransfer" name="data.dt_needtransfer" v-model="data.dt_needtransfer" v-validate="(data.wf_status_saved === 'CHECK')?{date_format:'yyyy-MM-dd', required:true}:''"
                                           hasToKeyboard="auto" value=""
                                           :title="$t('Document.dt_needtransfer')"
                                           placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_needtransfer')"
                                           :disabled="String(!(data.wf_status_saved === 'CHECK'))"
                                           :readonly="String(!(data.wf_status_saved === 'CHECK'))"
                                />
                                <small class="form-text text-muted"></small>
                                <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_needtransfer" dataKey="paymentDate"-->
                                <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                              </div>
                            </div>

                          </template>


                          <template v-if="data.wf_status_saved !== 'UPLOADING'">

                            <div class="row form-group">
                              <div class="col col-md-3"><label for="dt_transfer" class=" form-control-label">{{ $t('InvoiceInbound.dt_transfer') }} ({{ $t('validator.required')
                                }})</label>
                              </div>
                              <div class="col-12 col-md-9">
                                <InputText type="DatetimepickerBp"
                                           id="dt_transfer" name="data.dt_transfer" v-model="data.dt_transfer" v-validate="{date_format:'yyyy-MM-dd', required:false}" hasToKeyboard="auto" value=""
                                           :title="$t('InvoiceInbound.dt_transfer')"
                                           placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_transfer')"
                                           :disabled="String(!(data.wf_status_saved === 'TOBEREVIEWED' && HelperRole.hasRights(state, [14], [18] ) ) )"
                                           :readonly="String(!(data.wf_status_saved === 'TOBEREVIEWED' && HelperRole.hasRights(state, [14], [18] ) ) )"
                                />
                                <small class="form-text text-muted"></small>
                                <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_transfer" dataKey="paymentDate"-->
                                <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                                <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.dt_transfer" dataKey="dt_transfer"
                                                      :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                              </div>
                            </div>

                          </template>


                          <template v-if="data.wf_status_saved !== 'UPLOADING' ">
                            <div class="row form-group">
                              <div class="col col-md-3"><label class=" form-control-label">{{ $t('InvoiceInbound.transfered') }}</label>
                              </div>
                              <div class="col-12 col-md-9">
                                <select id="transfered" v-model="data.transfered" class="form-control mandatory w100" name="transfered"
                                        :disabled="data.wf_status_saved !== 'TOBEREVIEWED' || !HelperRole.hasRights(state, [14], [18] )"
                                        :readonly="data.wf_status_saved !== 'TOBEREVIEWED' || !HelperRole.hasRights(state, [14], [18] )"
                                >
                                  <option value="0">{{$t('global.no')}} </option>
                                  <option value="1">{{$t('global.yes')}} </option>
                                </select>
                              </div>
                            </div>
                          </template>


                          <!--TERMÉKEK ELEJE-->

                          <template v-if="false">
                            <!--<template v-if="viewRole!==0">-->
                            <!--<div class="col col-12">-->
                            <!--<hr>-->
                            <!--</div>-->
                            <!--</template>-->


                            <!--<div class="row">-->
                            <!--<div class="col">-->


                            <!--<div class="row form-group">-->
                            <!--<div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('Document.discount') }} ({{ $t('validator.required')-->
                            <!--}})</label>-->
                            <!--</div>-->
                            <!--<div class="col-12 col-md-9">-->
                            <!--<InputText id="discount" name="data.discount" v-model="data.discount" v-validate="'required|numeric'" hasToKeyboard="auto" value=""-->
                            <!--:title="$t('Document.discount')"-->
                            <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.discount')"-->
                            <!--:readonly="String(Number(viewRole)===0)"-->
                            <!--:disabled="String(Number(viewRole)===0)"-->
                            <!--/>-->
                            <!--<small class="form-text text-muted"></small>-->
                            <!--</div>-->
                            <!--</div>-->


                            <!--</div>-->
                            <!--</div>-->

                            <!--<table class="w100 mb-3">-->
                            <!--<tr>-->
                            <!--<td class="w1">-->
                            <!--<label class=" form-control-label"></label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_element_name') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_vatpercent') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_pack') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_countnum') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_price_net') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_price') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_price_vat') }}</label>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<label class=" form-control-label">{{ $t('Document.item_sumprice') }}</label>-->
                            <!--</td>-->
                            <!--</tr>-->
                            <!--<tr v-for="(e,index) in elementKeys">-->
                            <!--<template v-if="false || (isNaN(Number(element[e].rowtype)) || Number(element[e].rowtype)===0) && Number(element[e].deleted)===0">-->

                            <!--<td class="w1">-->
                            <!--<button class="btn btn-primary input-group-addon" v-if="element[e].item_key" v-on:click="linkRow('selproduct',element[e].item_key)">-->
                            <!--<div class=" "><i class="fa fa-link"></i></div>-->
                            <!--</button>-->
                            <!--</td>-->
                            <!--<td class="mw80 wname">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="'item_element_name'+element[e]['item_element_name']" :name="'item_element_name'+element[e]['item_element_name']"-->
                            <!--v-model="element[e].item_element_name" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" value="" classNameContainer="d-block w100"-->
                            <!--:title="$t('Document.item_element_name')"-->
                            <!--placeholder="..." dataLayout="tn" className="form-control mandatory w100" :hasError="errorMaker(element[e].item_element_name)"-->
                            <!--:hasErrorx="errors.has('element[e].item_element_name')"-->
                            <!--:readonly="String(element[e].item_key||viewRole==0||viewRole==1||viewRole==2)"-->
                            <!--:disabled="String(element[e].item_key||viewRole==0||viewRole==1||viewRole==2)"-->
                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<select :id="'item_id_vat'+index" :name="'item_id_vat'+index"-->
                            <!--v-model="element[e].item_id_vat" v-validate="'required'"-->
                            <!--:title="$t('Document.id_vat')"-->
                            <!--class="form-control mandatory w100" :hasError="errors.has('item_id_vat'+index)"-->
                            <!--@change="fnKeyup($event)" :data-props="e+'|item_id_vat'"-->
                            <!--:readonly="element[e].item_key||viewRole==0||viewRole==1||viewRole==2"-->
                            <!--:disabled="element[e].item_key||viewRole==0||viewRole==1||viewRole==2"-->
                            <!--&gt;-->
                            <!--<option v-for="option in vats" :value="''+option.id">{{option.vat_text }}</option>&lt;!&ndash;+ " ("+option.cardinality+" %)"&ndash;&gt;-->
                            <!--</select>-->
                            <!--&lt;!&ndash;<select :id="'item_vatpercent'+element[e]['item_vatpercent']" :name="'item_vatpercent'+element[e]['item_vatpercent']"&ndash;&gt;-->
                            <!--&lt;!&ndash;v-model="element[e].item_vatpercent" v-validate="'required'"&ndash;&gt;-->
                            <!--&lt;!&ndash;:title="$t('Document.item_vatpercent')"&ndash;&gt;-->
                            <!--&lt;!&ndash;class="form-control mandatory w100" :hasError="errors.has('element[e].item_vatpercent')"&ndash;&gt;-->
                            <!--&lt;!&ndash;@change="fnKeyup($event)" :data-props="e+'|item_vatpercent'"&ndash;&gt;-->
                            <!--&lt;!&ndash;&gt;&ndash;&gt;-->
                            <!--&lt;!&ndash;<option v-for="option in vats" :value="''+option.id">{{option.vat_text }}</option>&lt;!&ndash;+ " ("+option.cardinality+" %)"&ndash;&gt;&ndash;&gt;-->
                            <!--&lt;!&ndash;</select>&ndash;&gt;-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<select :id="'item_pack'+element[e]['item_pack']" :name="'item_pack'+element[e]['item_pack']" v-model="element[e].item_pack" v-validate="'required'"-->
                            <!--:title="$t('Document.item_pack')"-->
                            <!--class="form-control mandatory w100" :hasError="errors.has('element[e].item_pack')"-->
                            <!--:readonly="element[e].item_key||viewRole==0||viewRole==1||viewRole==2"-->
                            <!--:disabled="element[e].item_key||viewRole==0||viewRole==1||viewRole==2"-->
                            <!--&gt;-->
                            <!--<option v-for="option in packs" :value="option.key">{{ $t(option.value) }}</option>-->
                            <!--</select>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="'item_countnum'+element[e]['item_countnum']" :name="'item_countnum'+element[e]['item_countnum']" v-model="element[e].item_countnum"-->
                            <!--v-validate="'required'"-->
                            <!--hasToKeyboard="auto" value=""-->
                            <!--:title="$t('Document.item_countnum')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errorMaker(element[e].item_countnum)"-->
                            <!--:hasErrorx="errors.has('element[e].item_countnum')"-->
                            <!--:keyup="fnKeyup" :keydown="fnKeydow" :dataprops="e+'|item_countnum'"-->
                            <!--:readonly="String(Number(viewRole)===0)"-->
                            <!--:disabled="String(Number(viewRole)===0)"-->

                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="'item_price_net'+element[e]['item_price_net']" :name="'item_price_net'+element[e]['item_price_net']"-->
                            <!--v-model="element[e].item_price_net" v-validate="'required'"-->
                            <!--hasToKeyboard="auto"-->
                            <!--value=""-->
                            <!--:title="$t('Document.item_price_net')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errorMaker(element[e].item_price_net)"-->
                            <!--:hasErrorx="errors.has('element[e].item_price_net')"-->
                            <!--:keyup="fnKeyup" :keydown="fnKeydow" :afterAccept="fnKeyup" :dataprops="e+'|item_price_net'"-->

                            <!--:readonly="String(    (Number(viewRole)===0||Number(viewRole)===1||(Number(viewRole)===3&&element[e].item_key)) && (Number(element[e].item_pack)!==1||Helper.base_item!=='net')   )"-->
                            <!--:disabled="String(    (Number(viewRole)===0||Number(viewRole)===1||(Number(viewRole)===3&&element[e].item_key)) && (Number(element[e].item_pack)!==1||Helper.base_item!=='net')   )"-->
                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="'item_price'+element[e]['item_price']" :name="'item_price'+element[e]['item_price']" v-model="element[e].item_price"-->
                            <!--v-validate="'required'" hasToKeyboard="auto"-->
                            <!--value=""-->
                            <!--:title="$t('Document.item_price')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errorMaker(element[e].item_price)"-->
                            <!--:hasErrorx="errors.has('element[e].item_price')"-->
                            <!--:keyup="fnKeyup" :keydown="fnKeydow" :afterAccept="fnKeyup" :dataprops="e+'|item_price'"-->

                            <!--:readonly="String(    (Number(viewRole)===0||Number(viewRole)===1||(Number(viewRole)===3&&element[e].item_key)) && (Number(element[e].item_pack)!==1||Helper.base_item!=='gross')   )"-->
                            <!--:disabled="String(    (Number(viewRole)===0||Number(viewRole)===1||(Number(viewRole)===3&&element[e].item_key)) && (Number(element[e].item_pack)!==1||Helper.base_item!=='gross')   )"-->

                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="'item_price_vat'+element[e]['item_price_vat']" :name="'item_price_vat'+element[e]['item_price_vat']"-->
                            <!--v-model="element[e].item_price_vat" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" readonly disabled-->
                            <!--value=""-->
                            <!--:title="$t('Document.item_price_vat')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errors.has('element[e].item_price_vat')"-->
                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="'item_sumprice'+element[e]['item_sumprice']" :name="'item_sumprice'+element[e]['item_countnum']" v-model="element[e].item_sumprice"-->
                            <!--v-validate="'required'"-->
                            <!--hasToKeyboard="auto" value="" readonly disabled-->
                            <!--:title="$t('Document.item_sumprice')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errors.has('element[e].item_sumprice')"/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<template v-if="Number(viewRole)!==0">-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group buttonsContainer">-->
                            <!--<a class="btn_delrow input-group-addon " v-on:click="blockdown('element',index)">-->
                            <!--<div class=" "><i class="fa fa-arrow-down"></i></div>-->
                            <!--</a>-->
                            <!--<a class="btn_delrow input-group-addon " v-on:click="blockup('element',index)">-->
                            <!--<div class=" "><i class="fa fa-arrow-up"></i></div>-->
                            <!--</a>-->
                            <!--<button class="btn_delrow input-group-addon input-group-addon-danger" v-on:click="blockdelrow('element',index)">-->
                            <!--<div class=" "><i class="fa fa-times"></i></div>-->
                            <!--</button>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--</template>-->
                            <!--</template>-->
                            <!--</tr>-->
                            <!--<tr>-->
                            <!--<td colspan="2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="inputpositioner"></div>-->
                            <!--<template v-if="viewRole==3||viewRole==4">-->
                            <!--<button class="addrow input-group-addon input-group-addon-success" v-on:click="blockaddrow('element')">-->
                            <!--<div class=" "><i class="fa fa-plus"></i></div>-->
                            <!--</button>-->
                            <!--</template>-->
                            <!--<template v-if="viewRole==1||viewRole==2||viewRole==3||viewRole==4">-->
                            <!--<ElementSearcher v-model="xactElCount" textKey="global.elementSearch"></ElementSearcher>-->
                            <!--</template>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--</tr>-->
                            <!--<template v-if="!isNaN(Number(data.discount)) && Number(data.discount)>0">-->
                            <!--<tr v-for="(e,index) in discountsKeys">-->
                            <!--<td class="w1">-->
                            <!--</td>-->
                            <!--<td class="mw80 wname">-->
                            <!--<div class="input-group">-->
                            <!--{{ $t('global.discount') }}-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->

                            <!--<InputText :id="discounts[e].item_vatpercent" :name="discounts[e].item_vatpercent" v-model="discounts[e].item_vatpercent" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" readonly disabled-->
                            <!--value=""-->
                            <!--:title="$t('Document.item_vatpercent')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errorMaker(discounts[e].item_vatpercent)"-->
                            <!--:hasErrorx="errors.has('discounts[e].item_vatpercent')"-->
                            <!--:keyup="fnKeyup" :keydown="fnKeydow" :dataprops="e+'|item_vatpercent'"-->
                            <!--/>-->

                            <!--&lt;!&ndash;{{discounts[e].id_vat}}- &ndash;&gt;-->
                            <!--&lt;!&ndash;{{ discounts[e].item_vatpercent}}&ndash;&gt;-->

                            <!--&lt;!&ndash;<select :id="discounts[e].item_vatpercent" :name="discounts[e].item_vatpercent" v-model="discounts[e].item_vatpercent" v-validate="'required'"&ndash;&gt;-->
                            <!--&lt;!&ndash;:title="$t('Document.item_vatpercent')"&ndash;&gt;-->
                            <!--&lt;!&ndash;readonly disabled&ndash;&gt;-->
                            <!--&lt;!&ndash;class="form-control mandatory w100" :hasError="errors.has('discounts[e].item_vatpercent')"&ndash;&gt;-->
                            <!--&lt;!&ndash;@change="fnKeyup($event)" :data-props="e+'|item_vatpercent'"&ndash;&gt;-->
                            <!--&lt;!&ndash;&gt;&ndash;&gt;-->
                            <!--&lt;!&ndash;&lt;!&ndash;<option value="">-</option>&ndash;&gt;&ndash;&gt;-->
                            <!--&lt;!&ndash;<option v-for="option in vats" :value="option.id">{{option.vat_text }}</option>&lt;!&ndash;+ " ("+option.cardinality+" %)"&ndash;&gt;&ndash;&gt;-->
                            <!--&lt;!&ndash;</select>&ndash;&gt;-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="discounts[e].item_price_net" :name="discounts[e].item_price_net" v-model="discounts[e].item_price_net" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" readonly disabled-->
                            <!--value=""-->
                            <!--:title="$t('Document.item_price_net')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errorMaker(discounts[e].item_price_net)"-->
                            <!--:hasErrorx="errors.has('discounts[e].item_price_net')"-->
                            <!--:keyup="fnKeyup" :keydown="fnKeydow" :dataprops="e+'|item_price_net'"-->
                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="discounts[e].item_price" :name="discounts[e].item_price" v-model="discounts[e].item_price" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" readonly disabled-->
                            <!--value="" :title="$t('Document.item_price')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errorMaker(discounts[e].item_price)"-->
                            <!--:hasErrorx="errors.has('discounts[e].item_price')"-->
                            <!--:keyup="fnKeyup" :keydown="fnKeydow" :dataprops="e+'|item_price'"-->
                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="discounts[e].item_price_vat" :name="discounts[e].item_price_vat" v-model="discounts[e].item_price_vat" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" readonly disabled-->
                            <!--value=""-->
                            <!--:title="$t('Document.item_price_vat')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errors.has('discounts[e].item_price_vat')"-->

                            <!--/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--<div class="input-group">-->
                            <!--<InputText :id="discounts[e].item_sumprice" :name="discounts[e].item_countnum" v-model="discounts[e].item_sumprice" v-validate="'required'"-->
                            <!--hasToKeyboard="auto" value="" readonly disabled-->
                            <!--:title="$t('Document.item_sumprice')"-->
                            <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100" :hasError="errors.has('discounts[e].item_sumprice')"/>-->
                            <!--</div>-->
                            <!--</td>-->
                            <!--<td class="mw80">-->
                            <!--</td>-->
                            <!--</tr>-->
                            <!--</template>-->
                            <!--</table>-->

                          </template>
                          <!--TERMÉKEK VÉGE-->


                          <div class="row">
                            <div class="col">

                              <div class="row form-group">
                                <div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('Document.price_sum_net') }} ({{ $t('validator.required')
                                  }})</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="price_sum_net" name="data.price_sum_net" v-model="data.price_sum_net" v-validate="'required'" hasToKeyboard="auto" value=""
                                             :title="$t('Document.price_sum_net')"
                                             :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                             :readonly="String(data.wf_status_saved !== 'UPLOADING')"

                                             placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_sum_net')"/>
                                  <small class="form-text text-muted"></small>
                                  <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_net" dataKey="invoiceNetAmountHUF"-->
                                  <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_net" dataKey="price_sum_net"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                </div>
                              </div>
                              <div class="row form-group">
                                <div class="col col-md-3"><label for="price_sum" class=" form-control-label">{{ $t('Document.price_vat') }} ({{ $t('validator.required')
                                  }})</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="price_vat" name="data.price_vat" v-model="data.price_vat" v-validate="''" hasToKeyboard="auto" value=""
                                             :title="$t('Document.price_vat')"
                                             :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                             :readonly="String(data.wf_status_saved !== 'UPLOADING')"

                                             placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_vat')"/>
                                  <small class="form-text text-muted"></small>
                                  <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_vat" dataKey="invoiceVatAmountHUF"-->
                                  <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_vat" dataKey="price_vat"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                </div>
                              </div>
                              <div class="row form-group">
                                <div class="col col-md-3"><label for="price_sum" class=" form-control-label">{{ $t('Document.price_sum') }} ({{ $t('validator.required')
                                  }})</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="price_sum" name="data.price_sum" v-model="data.price_sum" v-validate="'required'" hasToKeyboard="auto" value=""
                                             :title="$t('Document.price_sum')"
                                             :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                             :readonly="String(data.wf_status_saved !== 'UPLOADING')"

                                             placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_sum')"/>
                                  <small class="form-text text-muted"></small>
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum" dataKey="price_sum"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                </div>
                              </div>

                              <hr>


                              <div class="row form-group">
                                <div class="col col-md-3"><label class=" form-control-label">{{ $t('InvoiceInbound.currency') }}</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <select id="currency" v-model="data.currency" class="form-control mandatory w100" name="currency"
                                          :disabled="data.wf_status_saved !== 'UPLOADING'"
                                          :readonly="data.wf_status_saved !== 'UPLOADING'"
                                  >
                                    <!--disabled="true"-->
                                    <!--readonly="true"-->
                                    <option value="">-</option>
                                    <option value="HUF">HUF</option>
                                    <option value="EUR">EUR</option>
                                    <option value="USD">USD</option>
                                  </select>
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.currency" dataKey="currency"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>                                </div>
                              </div>


                              <template v-if="data.currency!=='HUF'">

                              <div class="row form-group">
                                <div class="col col-md-3"><label for="price_sum_net_currency" class=" form-control-label">{{ $t('InvoiceInbound.price_sum_net_currency') }} ({{ $t('validator.required')
                                  }})</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="price_sum_net_currency" name="data.price_sum_net_currency" v-model="data.price_sum_net_currency" v-validate="data.currency!=='HUF'?'required':''" hasToKeyboard="auto" value=""
                                             :title="$t('Document.price_sum_net_currency')"
                                             :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                             :readonly="String(data.wf_status_saved !== 'UPLOADING')"

                                             placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_sum_net_currency')"/>
                                  <small class="form-text text-muted"></small>
                                  <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_net_currency" dataKey="invoiceNetAmountHUF"-->
                                  <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_net_currency" dataKey="price_sum_net_currency"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>

                                </div>
                              </div>
                              <div class="row form-group">
                                <div class="col col-md-3"><label for="price_sum" class=" form-control-label">{{ $t('InvoiceInbound.price_vat_currency') }} ({{ $t('validator.required')
                                  }})</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="price_vat_currency" name="data.price_vat_currency" v-model="data.price_vat_currency" v-validate="data.currency!=='HUF'?'required':''" hasToKeyboard="auto" value=""
                                             :title="$t('Document.price_vat_currency')"
                                             :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                             :readonly="String(data.wf_status_saved !== 'UPLOADING')"

                                             placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_vat_currency')"/>
                                  <small class="form-text text-muted"></small>
                                  <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_vat_currency" dataKey="invoiceVatAmountHUF"-->
                                  <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>- -->
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_vat_currency" dataKey="price_vat_currency"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                </div>
                              </div>
                              <div class="row form-group">
                                <div class="col col-md-3"><label for="price_sum_currency" class=" form-control-label">{{ $t('InvoiceInbound.price_sum_currency') }} ({{ $t('validator.required')
                                  }})</label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="price_sum_currency" name="data.price_sum_currency" v-model="data.price_sum_currency" v-validate="data.currency!=='HUF'?'required':''" hasToKeyboard="auto" value=""
                                             :title="$t('Document.price_vat_currency')"
                                             :disabled="String(data.wf_status_saved !== 'UPLOADING')"
                                             :readonly="String(data.wf_status_saved !== 'UPLOADING')"

                                             placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_sum_currency')"/>
                                  <small class="form-text text-muted"></small>
                                  <!--<NavDataDiffDisplayer defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_currency" dataKey="invoiceVatAmountHUF"-->
                                  <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>- -->
                                  <NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_currency" dataKey="price_sum_currency"
                                                        :dataObjectStr="data.navdata"></NavDataDiffDisplayer>
                                </div>
                              </div>

                              </template>

                              <div class="row form-group">
                                <div class="col col-md-3"><label for="text" class=" form-control-label">{{ $t('Document.text') }}
                                  <span class="validatorrequired"></span></label>
                                </div>
                                <div class="col-12 col-md-9">
                                  <InputText id="text" name="data.text" v-model="data.text" v-validate="''" hasToKeyboard="auto" value=""
                                             :title="$t('Document.text')" :readonly="(Number(viewRole) === 0)?'readonly':void 0" :disabled="(Number(viewRole) === 0)?'disabled':void 0"
                                             placeholder="..." dataLayout="tn" className="form-control " :hasError="errors.has('data.text')"/>
                                  <small class="form-text text-muted"></small>
                                </div>
                              </div>

                              <hr>


                              <template v-if="hasnav">
                                <div class="row form-group">
                                  <div class="col col-md-8"><label for="navGetDetails" class=" form-control-label">{{ $t('InvoiceInbound.navGetDetails') }}</label>
                                  </div>
                                  <div class="col-12 col-md-4 text-right">
                                    <button type="submit" id="navGetDetails" class="btn btn-primary btn-sm" v-on:click="navGetDetails">
                                      <i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}
                                    </button>
                                    <small class="form-text text-muted"></small>
                                  </div>
                                </div>
                                <div class="row form-group">
                                  <div class="col col-md-3"><label for="navdata" class=" form-control-label">{{ $t('InvoiceInbound.navdata') }} </label>
                                  </div>
                                  <div class="col-12 col-md-9">
                                    <textarea id="navdata" class="w100 h100" readonly disabled v-model="data.navdata"></textarea>
                                  </div>
                                </div>
                              </template>
                              <!--<InputText id="navdata" name="data.navdata" v-model="data.navdata" v-validate="''" hasToKeyboard="auto" value=""-->
                                         <!--:title="$t('Document.navdata')"-->
                                         <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.navdata')"/>-->




                              <!--<div class="row form-group">EZ talán NEM KELL-->
                                <!--<div class="col col-md-3"><label for="price_sum_currency" class=" form-control-label">{{ $t('InvoiceInbound.price_sum_currency') }} ({{ $t('validator.required')-->
                                  <!--}})</label>-->
                                <!--</div>-->
                                <!--<div class="col-12 col-md-9">-->
                                  <!--<InputText id="price_sum_currency" name="data.price_sum_currency" v-model="data.price_sum_currency" v-validate="'required'" hasToKeyboard="auto" value=""-->
                                             <!--:title="$t('Document.price_sum_currency')"-->
                                             <!--:disabled="String(data.wf_status_saved !== 'UPLOADING')"-->
                                             <!--:readonly="String(data.wf_status_saved !== 'UPLOADING')"-->

                                             <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.price_sum_currency')"/>-->
                                  <!--<small class="form-text text-muted"></small>-->
                                  <!--<NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav" :value="data.price_sum_currency" dataKey="invoiceVatAmountHUF"-->
                                                        <!--:dataObjectStr="data.lastlistquerycontent"></NavDataDiffDisplayer>-->
                                <!--</div>-->
                              <!--</div>-->


                              <template v-if="hasnav">

                                <div class="row form-group">
                                  <div class="col col-md-3"><label for="price_sum" class=" form-control-label">{{ $t('InvoiceInbound.lastlistquerycontent') }} </label>
                                  </div>
                                  <div class="col-12 col-md-9">
                                    <textarea class="w100 h100" readonly disabled>{{data.lastlistquerycontent}}</textarea>
                                  </div>
                                </div>

                                <!--<div class="row form-group">-->
                                  <!--<div class="col col-md-3"><label for="navGetDetails" class=" form-control-label">{{ $t('InvoiceInbound.navGetDetails') }}</label>-->
                                  <!--</div>-->
                                  <!--<div class="col-12 col-md-9">-->
                                    <!--<button type="submit" id="navGetDetails" class="btn btn-primary btn-sm" v-on:click="navGetDetails">-->
                                      <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}-->
                                    <!--</button>-->
                                    <!--<small class="form-text text-muted"></small>-->
                                  <!--</div>-->
                                <!--</div>-->

                                <div class="row form-group">
                                  <div class="col col-md-3"><label for="price_sum" class=" form-control-label">{{ $t('InvoiceInbound.lastdetailscontent') }} </label>
                                  </div>
                                  <div class="col-12 col-md-9">
                                    <textarea class="w100 h100" readonly disabled>{{data.lastdetailscontent}}</textarea>
                                  </div>
                                </div>


                              </template>


                              <div>

                                <!--&#45;&#45;<ProductSelector>++</ProductSelector>&#45;&#45;-->

                              </div>


                            </div>
                          </div>

                        </div>

                      </div>
                    </div>


                  </template>

                </div>
              </div>


              <div class="card-footer">
                <template v-if="Number(viewRole)!==0">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="doSave">
                    <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                  </button>
                  &nbsp;
                  <template v-if="wf_status_saved==='UPLOADING'">
                    <button type="button" class="btn btn-danger btn-sm" v-on:click="doDelete">
                      <i class="fa fa-ban"></i> {{$t('global.delete')}}
                    </button>
                  </template>
                  <!--&nbsp;-->
                  <!--<button type="submit" class="btn btn-warning btn-sm" v-on:click="saveAndFinalize()">-->
                  <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.saveAndFinalize')}}-->
                  <!--</button>-->
                  <!--<button type="reset" class="btn btn-danger btn-sm">-->
                  <!--<i class="fa fa-ban"></i> Reset-->
                  <!--</button>-->
                </template>

              </div>
            </div>

          </div>
        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import SettingsContainer from '@/helper/SettingsContainer';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import HelperPdf from '@/helper/HelperPdf';
  import PdfMake from '@/components/PdfMake.vue';
  import BarcodeGenerator from '@/components/BarcodeGenerator.vue';
  import JsBarcode from 'jsbarcode';
  import MenuToggle from '@/components/MenuToggle.vue';
  import InputText from '@/components/InputText.vue';
  import FileUploader from '@/components/FileUploader.vue';
  import ImageDisplayer from '@/components/ImageDisplayer.vue';
  //  import ProductSelector from '@/components/ProductSelector.vue';
  import ElementSearcher from '@/components/ElementSearcher.vue';
  import NavDataDiffDisplayer from '@/components/NavDataDiffDisplayer.vue';
  import BusinessPartnerSearcher from '@/components/BusinessPartnerSearcher.vue';
  const moment = require('moment');

  export default {
    name: 'InvoiceInbound',
    data() {
      return {
//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        , docDefinition: {}

        , viewRole: 4// | 0 semmi, csak megnézés ,| 1 semmi, csak a mennyiség - | 2 mennyiség netto ár bruttó ár - | 3 semmi, csak a mennyiség + free edit  | 4 mennyiség netto ár bruttó ár + free edit
        , definitive: 0
        ,
        element: {},
        elementKeys: [],
        vats: [],
        stores: [],
        packs: [
          {key: '1', value: 'global.money'},
          {key: '2', value: 'global.pc'},
          {key: '3', value: 'global.kg'},
          {key: '4', value: 'global.l'},
          {key: '5', value: 'global.m'},
          {key: '6', value: 'global.pack'},
          {key: '7', value: 'global.occasion'},
        ],
        businesspartners: [{id: 1, name: ""}],
        businesspartnerid: void 0,
        businesspartner: void 0,
        businesspartnerdata: {},
        companydata: {},
        discountsKeys: [],
        discounts: {},
        item_price: 0,
        item_price_net: 0,
        item_price_vat: 0,
        item_sumprice: 0,
        outerprogsupplier: false,
        businesspartnersearcher: false,
//        check: true,
        data: {
          "discount": "0",
          wf_status: "UPLOADING"
        }
        , dataDefault: { // need for change without save
          "discount": "0",
          wf_status: "UPLOADING"
        }
        , price_round: 2
        , base_item: "gross"

        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }
        , breadcrumbstitle: 'InvoiceInbound.title'
        , breadcrumbsData: [
          {
            'title': "InvoiceInbound.title",
          }
        ]
        , barcode: ""
        , settings: []
        , default_type: ""
        , default_presuf: ""
        , default_fix: ""
        , footertext: ""
        , defaultdtpaymentdeadline: ""

        , wf_statuses: [
          {text: "uploading", value: "UPLOADING"},
          {text: "check", value: "CHECK"}
        ]
        , wf_status_saved: "UPLOADING"

        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""

        , hasnav: false
        , file: ""
        , images: []

        , openIssuer: false
        , openBuyer: false
      };
    },
    computed: {
      xactElCount: {
        get(){
          //this function will determine what is displayed in the input
          return "";
        },
        set(newVal){
          const modul = this;
          //this function will run whenever the input changes
          modul.addElement(newVal);
        }
      }
    },
//    props: {
//      id: String,
//    },


    mounted() {
      console.log("InvoiceInbound");
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();

//      modul.hasRole = Helper.checkRolesAuto(this, [3, 6, 1, 12], 13);
//      if (this.$route.params && this.$route.params.contactType && this.$route.params.dataId) {
//        if (this.$route.params.contactType === "businesspartner") {
//          modul.data.id_businesspartner = this.$route.params.dataId;
//        }
//        if (this.$route.params.contactType === "store") {
//          modul.data.id_store = this.$route.params.dataId;
//        }
//        if (this.$route.params.contactType === "id_address") {
//          modul.data.id_address = this.$route.params.dataId;
//        }
//      } else {
//        modul.getStores();
//        modul.getCompanyData();
//      }
//      if (Helper.base_item) {
//        modul.base_item = Helper.base_item;
//      }
//      modul.viewRole = 1;
//      this.updateSettings();
//      this.getBusinessPartners();
//      this.getDeliveryNote();
      modul.$eventBus.$on('globalSetBusinessPartner', this.globalSetBusinessPartnerEventHandler);
//      modul.$eventBus.$on('globalReadElement', this.globalReadElementEventHandler);
    },
    beforeDestroy() {
      this.$eventBus.$off('globalSetBusinessPartner');
//      this.$eventBus.$off('globalReadElement');
    },
    watch: {

      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        console.log("healthCheckHash");
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElement();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        console.log('hasRole');
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

      '$route.params': function (newdata, olddata) {
        console.log('$route.params');
        if (this.$route.params.id) {
          this.id = newdata;
//          this.getElement();
        } else {
          this.id = void 0;
        }
      },

//      '$store.state.userhash': function (newVal, oldVal) {
//        const modul = this;
//        modul.handleRights();
//      },
//      'hasRole': function (newVal, oldVal) {
//        const modul = this;
//        if (newVal && !oldVal) {
//          if (modul.hasRole && modul.hasCompany) {
//            modul.init();
//          }
//        }
//      },
//      '$store.state.id_company': function (newVal, oldVal) {
//        const modul = this;
//        modul.modules = [];
//        modul.company2modul = [];
//        modul.company2modulModel = [];
//        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
//        }
//      },
//
//      // TODO -- betenni az element-re is.
//      '$route.params': function (newdata, olddata) {
//        if (this.$route.params.id) {
//          this.id = newdata;
//        } else {
//          this.id = void 0;
//        }
////        this.getContact();
//      },


//      hasnav: function (newData, oldData) {
//        const modul = this;
//        if (localStorage) {
//          localStorage.setItem("hasnav", newData);
//        }
//        if (newData === "false") {
//          modul.hasnav = false;
//        }
//      },
      lang: function (newLang, oldLang) {
        const modul = this;
        modul.docDefinition = modul.makeDocDefinition();
      },
//      footertext: function (newdata, olddata) {
//        const modul = this;
//        modul.data.text2 = newdata;
//        modul.docDefinition = modul.makeDocDefinition();
//      },
      data: function (newdata, olddata) {
        const modul = this;
        if (newdata.wf_status) {


          const wf_statuses = [];


          const wfstatuses = {};
          wfstatuses.UPLOADING = false;
          wfstatuses.CHECK = false;
          wfstatuses.REJECTED = false;
          wfstatuses.TOBEREVIEWED = false;
          wfstatuses.CLOSED = false;

          // TODO -- Ide úgy kell listát generálni, hogy saját jogaim alapján keletkezzen a SELECT listája
          if (HelperRole.hasRights(modul.state, [14], [16])) { // feltöltő jog
            wfstatuses.UPLOADING = true;
            wfstatuses.CHECK = true;
          }
          if (HelperRole.hasRights(modul.state, [14], [17])) { // leader jog
            wfstatuses.UPLOADING = true;
            wfstatuses.CHECK = true;
            wfstatuses.REJECTED = true;
            wfstatuses.TOBEREVIEWED = true;
          }
          if (HelperRole.hasRights(modul.state, [14], [18])) { // finance jog
            wfstatuses.TOBEREVIEWED = true;
            wfstatuses.CLOSED = true;
          }
          if (HelperRole.hasRights(modul.state, [14], [19])) { // könyvelő jog
//            wfstatuses.UPLOADING = true;
//            wfstatuses.CHECK = true;
//            wfstatuses.REJECTED = true;
            wfstatuses.TOBEREVIEWED = true;
            wfstatuses.CLOSED = true;
          }
          if (wfstatuses.UPLOADING) {
            wf_statuses.push({text: "UPLOADING", value: "UPLOADING"});
          }
          if (wfstatuses.CHECK) {
            wf_statuses.push({text: "CHECK", value: "CHECK"});
          }
          if (wfstatuses.REJECTED) {
            wf_statuses.push({text: "REJECTED", value: "REJECTED"});
          }
          if (wfstatuses.TOBEREVIEWED) {
            wf_statuses.push({text: "TOBEREVIEWED", value: "TOBEREVIEWED"});
          }
          if (wfstatuses.CLOSED) {
            wf_statuses.push({text: "CLOSED", value: "CLOSED"});
          }


// OLD wf_status alapján
//          if (newdata.wf_status === "UPLOADING") {
//            wf_statuses.push({text: "uploading", value: "UPLOADING"});
//            wf_statuses.push({text: "check", value: "CHECK"});
//          }
//          if (newdata.wf_status === "CHECK") {
//            wf_statuses.push({text: "uploading", value: "UPLOADING"});
//            wf_statuses.push({text: "check", value: "CHECK"});
//            wf_statuses.push({text: "rejected", value: "REJECTED"});
//            wf_statuses.push({text: "payable", value: "TOBEREVIEWED"});
//          }
//          if (newdata.wf_status === "REJECTED") {
//            wf_statuses.push({text: "rejected", value: "REJECTED"});
//          }
//          if (newdata.wf_status === "TOBEREVIEWED") {
//            wf_statuses.push({text: "payable", value: "TOBEREVIEWED"});
//            wf_statuses.push({text: "paid", value: "CLOSED"});
//          }
//          if (newdata.wf_status === "CLOSED") {
//            wf_statuses.push({text: "paid", value: "CLOSED"});
//          }
          modul.wf_statuses = wf_statuses;
        }
        if (newdata.id_businesspartner) {
          modul.businesspartnerid = newdata.id_businesspartner;
        }
        //modul.copyCompanyDataToModel();
//        modul.definitive = newdata.definitive;
//        if (Number(modul.definitive) !== 0) {
//          newdata.text2 = modul.footertext;
//        }
//        if (Number(modul.definitive) === 1) {
//          modul.viewRole = 0;
//        }
//        modul.docDefinition = modul.makeDocDefinition();
      },
//      "data.discount": function (newdata, olddata) {
//        const modul = this;
//        if (!newdata) {
////          newdata=0;
////          modul.data.discount=0;
//        }
//        if (newdata !== olddata) { //  && olddata
//          modul.fnFillEmptyPrices();
//          modul.fnCountSumPrices();
//        }
//      },
//      "data.payment_type": function (newData, oldData) {
//        const modul = this;
//        console.log("payment_type");
//        if (modul.data.definitive === 0) {
//          modul.data.dt_make = moment().format('YYYY-MM-DD');
//          modul.readonlycompletion = true;
//          modul.readonlypaymentdeadline = true;
//          if (Number(newData) === 1) {
//            modul.data.dt_completion = modul.data.dt_make;
//            modul.data.dt_paymentdeadline = modul.data.dt_make;
//            modul.readonlycompletion = false;
//            modul.readonlypaymentdeadline = false;
//          } else if (Number(newData) === 2) {
//            modul.data.dt_completion = modul.data.dt_make;
//            modul.data.dt_paymentdeadline = modul.data.dt_make;
//            modul.readonlycompletion = false;
//            modul.readonlypaymentdeadline = false;
//          } else if (Number(newData) === 3) {
//            modul.data.dt_completion = modul.data.dt_make;
//            modul.data.dt_paymentdeadline = moment().add(modul.defaultdtpaymentdeadline, 'days').format('YYYY-MM-DD')
//            modul.readonlycompletion = false;
//            modul.readonlypaymentdeadline = false;
//          }
//        }
//      },
//      element: function (newdata, olddata) {
//        const modul = this;
//        if (newdata && newdata.random && olddata && olddata.random && newdata.random !== olddata.random) {
//          modul.fnFillEmptyPrices();
//          modul.fnCountSumPrices();
//        }
////        if (modul.vats.length > 0 && Object.keys(newdata).length > 0) {
////          modul.docDefinition = modul.makeDocDefinition();
////        }
//      },
//      vats: function (newData, oldData) {
//        const modul = this;
//        if (modul.element.length > 0 && newData.length > 0) {
//          modul.docDefinition = modul.makeDocDefinition();
//        }
//      },
      businesspartnerdata: function (newdata, olddata) {
        const modul = this;
        modul.copyBusinessDataToModel("from");
      },
//      businesspartnerid: function (newdata, olddata) {
//        const modul = this;
//        modul.businesspartnerdata = {};
//        for (let x in modul.businesspartners) {
//          if (!modul.businesspartners.hasOwnProperty(x)) {
//            continue;
//          }
//          if ((newdata) === (modul.businesspartners[x].id)) {
//            modul.businesspartnerdata = modul.businesspartners[x];
//          }
//        }
//        modul.copyBusinessDataToModel("from");
//      },

//      companydata: function (newdata, olddata) {
//        const modul = this;
//        modul.copyCompanyDataToModel();
//      },
//      definitive: function (newdata, olddata) {
//        const modul = this;
//        if (Number(newdata) === 1) {
//          modul.viewRole = 0;
//        } else {
////          modul.viewRole = 0; // nem tudjuk milyen role-ra kell visszaállítani // TODO -- későb beállításokban lehet matatni
//        }
//      },
//      viewRole: function (newdata, olddata) {
//        const modul = this;
//        if (typeof newdata === "String") {
//          modul.viewRole = Number(newdata);
//        }
//      },

    },


    /**
     *  methods
     */
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16, 17, 18, 19])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
        if (modul.state && modul.state.settings) {
          modul.hasnav = (modul.state.settings.hasnav === "true");
        }
      },
      init(){
        const modul = this;
        modul.getElement();


//        window.iframe = document.getElementsByTagName('iframe')[0];
//        let html_string= '<!DOCTYPE html><html lang="en"><head><title>Title</title></head><body><h1>h1</h1><p>paragraph.</p><form action="/action_page_binary.asp" method="post" enctype="multipart/form-data"><label for="fname">file:</label><input type="file" id="img" name="img" accept="image/*"><br><input type="submit" value="Submit"></form></body></html>';
//        window.iframe.src = "data:text/html;charset=utf-8," + escape(html_string);
//        window.iFrameBody = iframe.contentDocument.getElementsByTagName('body')[0];

      },
      fileUploadHadler(e){
        console.log("e");
        console.log(e);
      },
      imageClickHadler(e){
        console.log("e");
        console.log(e);
      },
      getElement(){
        const modul = this;
        let id = 0;
        try {
          id = (this.$route.params.id);
//          if (id) {
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.getInvoiceInbound({id: id, id_company: modul.state.id_company}).then(function (res) {
            console.log(res);
            if (res && res.result && res.data) {
              modul.data = (res.data.invoiceinbound) ? res.data.invoiceinbound : modul.dataDefault;
              modul.data.price_sum_net = Helper.getRemovedTrailingZero(Helper.Number(modul.data.price_sum_net)).toString();
              modul.data.price_vat = Helper.getRemovedTrailingZero(Helper.Number(modul.data.price_vat)).toString();
              modul.data.price_sum = Helper.getRemovedTrailingZero(Helper.Number(modul.data.price_sum)).toString();
              modul.data.price_sum_net_currency = Helper.getRemovedTrailingZero(Helper.Number(modul.data.price_sum_net_currency)).toString();
              modul.data.price_vat_currency = Helper.getRemovedTrailingZero(Helper.Number(modul.data.price_vat_currency)).toString();
              modul.data.price_sum_currency = Helper.getRemovedTrailingZero(Helper.Number(modul.data.price_sum_currency)).toString();
              // currency nem változik
              modul.vats = res.data.vats;
              modul.companydata = res.data.company;
              if (!modul.data.lastdetailscontent) {
                modul.navGetDetails();
              }
            }
            modul.data.wf_status_saved = modul.data.wf_status;
//            if (modul.data.wf_status === 'REJECTED' || modul.data.wf_status === 'CLOSED') {
//            }
            modul.AlertInPage.msg = "";
          }, function (e) {
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });
//          }
        } catch (e) {
          console.log(e);
        }
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
        this.$router.push({name: "Vat"})
      }
      ,

      // getQueryTaxpayer
      getQueryTaxpayer: function (direction) {
        const modul = this;
        let arrTaxnumber = "";
        if (direction && direction === "from" && modul.data.from_taxnumber) {
          arrTaxnumber = modul.data.from_taxnumber.split("-");
        } else if (direction && direction === "to" && modul.data.to_taxnumber) {
          arrTaxnumber = modul.data.to_taxnumber.split("-");
        } else if (!direction || direction === "" && modul.data.taxnumber) {
          arrTaxnumber = modul.data.taxnumber.split("-");
        }
        if (!arrTaxnumber) {
          modul.AlertInPage.msg = "BusinessPartner.taxPayerErrorEmpty";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const taxnumber = arrTaxnumber[0];
        if (taxnumber && taxnumber.length !== 8) {

          modul.AlertInPage.msg = "BusinessPartner.taxPayerErrorFormat";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const data = {};
        data.taxNumber = taxnumber;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";

        Api.navGetDataByTaxnumber({data: data, id_company: modul.state.id_company}).then(function (res) {
          console.log(res);
          if (res && res.result && res.data) {
//            modul.data = res.data;
            console.log(res.data)

            const data = Object.assign({}, res.data);

            if (direction && direction === "from") {
              const moduldata = Object.assign({}, modul.data);
              moduldata.from_building = Helper.String(data.building); //
              moduldata.from_name = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.from_nameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.from_city = Helper.String(data.city); // CSETÉNY"
              moduldata.from_county = Helper.String(data.county); //
              moduldata.from_door = Helper.String(data.door); //
              moduldata.from_email_def = Helper.String(data.email_def); //
              moduldata.from_floor = Helper.String(data.floor); //
              moduldata.from_house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.from_lot_number = Helper.String(data.lot_number); //
              moduldata.from_nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.from_phone_def = Helper.String(data.phone_def); //
              moduldata.from_public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.from_staircase = Helper.String(data.staircase); //
              moduldata.from_zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            } else if (direction && direction === "to") {
              const moduldata = Object.assign({}, modul.data);
              moduldata.to_building = Helper.String(data.building); //
              moduldata.to_name = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.to_nameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.to_city = Helper.String(data.city); // CSETÉNY"
              moduldata.to_county = Helper.String(data.county); //
              moduldata.to_door = Helper.String(data.door); //
              moduldata.to_email_def = Helper.String(data.email_def); //
              moduldata.to_floor = Helper.String(data.floor); //
              moduldata.to_house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.to_lot_number = Helper.String(data.lot_number); //
              moduldata.to_nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.to_phone_def = Helper.String(data.phone_def); //
              moduldata.to_public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.to_staircase = Helper.String(data.staircase); //
              moduldata.to_zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            } else if (!direction || direction === "") {
              const moduldata = Object.assign({}, modul.data);
              moduldata.building = Helper.String(data.building); //
              moduldata.name = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.nameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.city = Helper.String(data.city); // CSETÉNY"
              moduldata.county = Helper.String(data.county); //
              moduldata.door = Helper.String(data.door); //
              moduldata.email_def = Helper.String(data.email_def); //
              moduldata.floor = Helper.String(data.floor); //
              moduldata.house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.lot_number = Helper.String(data.lot_number); //
              moduldata.nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.phone_def = Helper.String(data.phone_def); //
              moduldata.public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.staircase = Helper.String(data.staircase); //
              moduldata.zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            }


          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "";

        });
      },

      // navGetDetails
      navGetDetails: function (direction) {
        const modul = this;
        if (!modul.data.identifier) {
          modul.AlertInPage.msg = "global.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const data = {};
        data.identifier = modul.data.identifier;
        data.taxnumber = modul.data.from_taxnumber;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";

        Api.navGetInvoiceDetailData({data: data, id_company: modul.state.id_company}).then(function (res) {
          console.log(res);
          if (res && res.result && res.data) {
            modul.data.navdata = res.data.navdata;
            modul.data = Object.assign({}, res.data);
            modul.data.wf_status_saved = modul.data.wf_status;
//            console.log(res.data)

          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "";

        });
      },

      globalSetBusinessPartnerEventHandler: function (obj) {
        const modul = this;
        if (obj && obj.id) {
//          modul.businesspartnerid = obj.id;
//          modul.businesspartners.push(obj);
          modul.businesspartnerdata = obj;
          modul.businesspartnersearcher = false;
        }
      },
//      globalReadElementEventHandler: function (obj) {
//        const modul = this;
//        if (obj && obj.id) {
//          modul.addElement(obj);
//        }
//      },
      businesspartnersearcherClick(){
        const modul = this;
        modul.businesspartnersearcher = true;
      },
      businesspartnersearcherClickClose(){
        const modul = this;
        modul.businesspartnersearcher = false;
      },
      openIssuerHandler(){
        const modul = this;
        modul.openIssuer = !modul.openIssuer;
      },
      openBuyerHandler(){
        const modul = this;
        modul.openBuyer = !modul.openBuyer;
      },
      fncb(key){
        const modul = this;
        try{
          modul.dataObject = JSON.parse(modul.data.navdata);
          if (modul.dataObject && modul.dataObject[key]) {
            modul.data[key] = modul.dataObject[key];
          }
        } catch (e){
        }
      }
//      ,
//      updateSettings(){
//        const modul = this;
//        Helper.updateSettings();
//        const settings = SettingsContainer.getSettings();
//        if (Array.isArray(settings)) {
//          Array.prototype.forEach.call(settings, function (e) {
//            if (e.typec_sub === "footertext") {
//              modul.footertext = e.valuec;
//            }
//            if (e.typec_sub === "base_item") {
//              modul.base_item = e.valuec;
//            }
//            if (e.typec_sub === "defaultdtpaymentdeadline") {
//              modul.defaultdtpaymentdeadline = e.valuec;
//            }
//          });
//        }
//      },
//      linkRow(url, id){
//        const modul = this;
//        if (confirm(modul.$t('global.linkRow'))) {
//          modul.$router.push({path: '/' + url + '/' + id});
//        }
//      },
//      addElement(element){
//        const modul = this;
//        const copiedElement = Object.assign({}, element);
//        delete(copiedElement['id']);
//        const dataRowObject = Object.assign({
//          "id": "",
//          "item_element_name": element.name,
//          "item_vatpercent": modul.getVatCardinalityByIdVat(element.item_id_vat), // item_vatpercent
//          "item_id_vat": element.item_id_vat, // item_vatpercent
//          "item_pack": element.pack,
//          "item_key": element.id,
//          "item_price": element.default_price,
//          "item_countnum": "1",
//          "item_sumprice": element.default_price,
//          "rowtype": 0,
//          "deleted": "0"
//        }, copiedElement);
//        modul.blockaddrow("element", dataRowObject);
//        setTimeout(function () {
//          modul.fnFillEmptyPrices();
//          modul.fnCountSumPrices();
//        }, 300);
//      },
//      getBusinessPartners(){
//        const modul = this;
//        Api.getBusinessPartners().then(function (res) {
//          console.log(res);
//          if (res && res.result) {
//            modul.businesspartners = res.data;
//          }
//        });
//      },
//      getStores(){
//        const modul = this;
//        Api.getStores().then(function (res) {
//          console.log(res);
//          if (res && res.result) {
//            modul.stores = res.data;
//          }
//        });
//      },
//      getCompanyData(){
//        const modul = this;
//        Api.getCompanyData().then(function (res) {
//          console.log(res);
//          if (res && res.result) {
//            modul.companydata = res.data;
//            modul.copyCompanyDataToModel();
//          }
//        });
//      },
//      getDeliveryNote(){
//        const modul = this;
//        let id = 0;
//        try {
//          id = Number(this.$route.params.id);
//          if (id > 0) {
//            Api.getDeliveryNote(id).then(function (res) {
//              console.log(res);
//              if (res && res.result) {
//                modul.data = res.data;
//
//                modul.data.price_sum_net = "" + Helper.getFormattedSumprice(res.data.price_sum_net);
//                modul.data.price_vat = "" + Helper.getFormattedSumprice(res.data.price_vat);
//                modul.data.price_sum = "" + Helper.getFormattedSumprice(res.data.price_sum);
//
//                const element = {};
//                const elementKeys = [];
//                if (res.elements) {
//                  const elements = res.elements;
//                  Array.prototype.forEach.call(elements, function (e, x) {
//                      const eCopy = {};
//                      for (let i in e) {
//                        if (!e.hasOwnProperty(i)) {
//                          continue;
//                        }
//                        if (e.rowtype !== 1 && e.rowtype !== "1") { // nem discount
//                          if (i === "item_price_net") {
//                            eCopy[i] = "" + Helper.getFormattedPrice(e[i]);
//                          } else if (i === "item_price_vat") {
//                            eCopy[i] = "" + Helper.getFormattedPrice(e[i]);
//                          } else if (i === "item_price") {
//                            eCopy[i] = "" + Helper.getFormattedPrice(e[i]);
//                          } else if (i === "item_sumprice_net") {
//                            eCopy[i] = "" + Helper.getFormattedPrice(e[i]);
//                          } else if (i === "item_sumprice_vat") {
//                            eCopy[i] = "" + Helper.getFormattedPrice(e[i]);
//                          } else if (i === "item_sumprice") {
//                            eCopy[i] = "" + Helper.getFormattedPrice(e[i]);
//                          } else {
//                            eCopy[i] = "" + e[i];
//                          }
////                        } else {
////                          if (i === "item_price_net") { // discount
////                            eCopy[i] = "" + Helper.getFormattedDiscount(e[i]);
////                          } else if (i === "item_price_vat") {
////                            eCopy[i] = "" + Helper.getFormattedDiscount(e[i]);
////                          } else if (i === "item_price") {
////                            eCopy[i] = "" + Helper.getFormattedDiscount(e[i]);
////                          } else if (i === "item_sumprice_net") {
////                            eCopy[i] = "" + Helper.getFormattedDiscount(e[i]);
////                          } else if (i === "item_sumprice_vat") {
////                            eCopy[i] = "" + Helper.getFormattedDiscount(e[i]);
////                          } else if (i === "item_sumprice") {
////                            eCopy[i] = "" + Helper.getFormattedDiscount(e[i]);
////                          } else {
////                            eCopy[i] = "" + e[i];
////                          }
//                        }
//                      }
//                      if (e.rowtype === 0 || e.rowtype === "0"
//                      ) { // element
//                        element["row" + x] = eCopy;
//                        elementKeys.push("row" + x);
////                    } else if (e.rowtype === 1) { // discounts
////                      discount["row" + x] = eCopy;
////                      discountsKeys.push("row" + x);
//                      }
//                    }
//                  )
//                }
//                modul.element = element;
//                modul.elementKeys = elementKeys;
//                if (res.vats) {
//                  modul.vats = res.vats;
//                }
//                if (res.stores) {
//                  modul.stores = res.stores;
//                }
//                if (res.companydata) {
//                  modul.companydata = res.companydata;
//                }
//                modul.makeDocDefinition();
//
//              }
//            })
//            ;
//          } else {
//            modul.data.dt_completion = moment().format('YYYY-MM-DD');
//            modul.data.dt_make = moment().format('YYYY-MM-DD');
//            const dayDelay = Helper.getDefaultdtpaymentdeadline();
//            modul.data.dt_paymentdeadline = moment().add(dayDelay, 'day').format('YYYY-MM-DD');
//          }
//        } catch
//          (e) {
//          console.log(e);
//        }
//      },
//      //      emptyForNew(){
//      //        this.data = Object.assign({}, this.dataBase);
//      //        this.$router.push({name: "InvoiceInbound"})
//      //      },
//      makeDocDefinition: function (cb, id) {
//        const modul = this;
//        const data = Object.assign({}, modul.data);
//        data.d = modul.data;
//        data.titleKey = "invoice.exampleinvoice";
//        if (Number(data.d && data.d.definitive) === 1) {
//          data.titleKey = "pdfi.deliverynote";
//        } else {
//          data.titleKey = "pdfi.exampledeliverynote";
//        }
//
//        data.d_elements = Object.values(modul.element);
//        data.vats = modul.vats;
//        data.packs = modul.packs;
//        if (modul.data && Number(modul.data.definitive) === 1) {
//          data.text = modul.data.text;
//          data.text2 = modul.data.text2;
//        } else {
//          data.text = modul.text;
//          data.text2 = modul.footertext;
//        }
//        if (modul.data && modul.data.from_store) {
//          data.from_store_name = Helper.getValueByIdAndKeyFromObjectArray("text", modul.stores, modul.data.from_store);
//        } else {
//          data.from_store_name = "";
//        }
//        if (modul.data && modul.data.to_store) {
//          data.to_store_name = Helper.getValueByIdAndKeyFromObjectArray("text", modul.stores, modul.data.to_store);
//        } else {
//          data.to_store_name = "";
//        }
////        if (localStorage) {
////          let logo = localStorage.getItem("logo");
////          if (!logo) {
//        data.logo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=';
////          }
////          if (logo) {
////            data.logo = logo;
////          }
////        }
//        data.type = "deliverynote";
//        data.direction = "OUTBOUND";
//        const prefix = Helper.getMoneyDefaultDisplayPrefix();
//        const suffix = Helper.getMoneyDefaultDisplaySuffix();
//        data.prefix = prefix;
//        data.suffix = suffix;
//        const docDefinition = HelperPdf.getDocDefinition(modul, data);
////                console.log("docDefinition");
////                console.log(JSON.stringify(docDefinition));
//        return docDefinition;
//      }
//      ,

//      saveAndFinalize()
//      {
//        const modul = this;
//        modul.save("finalize")
//
//      }
      ,
      doDelete(){
        const modul = this;
        const fnCb = function () {
          const req = {};
          req.id = modul.data.id;
          req.id_company = modul.state.id_company;
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";

          Api.deleteInvoiceInbound(req).then(function (res) {

            if (res && res.result) {
              modul.AlertInPage.msg = "global.success";
              modul.AlertInPage.type = "success";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));

              setTimeout(function (e) {
                modul.$router.push({
                  path: '/emptypage'
                });
                setTimeout(function (e) {
                  modul.$router.push({
                    path: '/invoiceinboundsuploader'
//                    name: "storevenue", params: {id: modul.data.id}
                  });
                }, 10);
              }, 300);

            } else {
              modul.AlertInPage.msg = "global.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));
              modul.AlertInPage.msg = "";

            }
          }, function (e) {
            modul.AlertInPage.msg = "";

          })

        };

        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: "",
          tmsgText: "areyousuredelete",
          fnCancel: function () {
            console.log('fnCancel')
          },
          fnConfirm: function () {
            console.log('fnConfirm')
            fnCb()
          }
        });

      },
      doSave(){
        const modul = this;
        if (modul.data.id) {
          modul.save()
        } else {
          // check
          modul.saveCheck()
        }

      },
      saveCheck(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "identifier", "id_businesspartner", "id_adminuser", "title", "dt_completion", "dt_make", "dt_paymentdeadline", "price_sum_net", "price_sum", "price_vat", "payment_type", "from_store", "to_store", "from_name", "from_taxnumber", "from_taxnumbercountrygroup", "from_taxnumberother", "from_registrationnumber", "from_bank_account", "from_zip", "from_public_space", "from_nature_of_public_space", "from_house_number", "from_building", "from_staircase", "from_floor", "from_door", "from_county", "from_city", "from_country", "from_phone_def", "from_email_def", "from_lot_number", "to_name", "to_taxnumber", "to_taxnumbercountrygroup", "to_taxnumberother", "to_registrationnumber", "to_bank_account", "to_zip", "to_public_space", "to_nature_of_public_space", "to_house_number", "to_building", "to_staircase", "to_floor", "to_door", "to_county", "to_city", "to_country", "to_phone_def", "to_email_def", "to_lot_number", "deleted"
              , "wf_status", "text", "text2", "price_sum_net_currency", "price_vat_currency", "price_sum_currency", "dt_transfer", "dt_needtransfer", "transfered", "currency", "navdata"]);
            const req = {};
            req.data = data;
            req.id_company = modul.state.id_company;
            const fnSave = modul.save;
            Api.saveCheckInvoiceInbound(req).then(function (res) {
              if (res && res.result && res.data && res.data.id) {
                // van ilyen, tehát kérdés
                modul.$eventBus.$emit('modal', {
                  type: "confirm",
                  msgTitle: "",
                  tmsgTitle: "question",
                  msgText: "",
                  tmsgText: "suchalreadyareyousuresave",
                  fnCancel: function () {
                    console.log('fnCancel')
                  },
                  fnConfirm: function () {
                    console.log('fnConfirm')
                    fnSave()
                  }
                });
              } else {
                fnSave()
              }
            })
          }
        })
      },
      save(type)
      {
        const modul = this;
        console.log("save()")
        modul.$validator.validateAll().then((result) => {
          if (result) {

            const data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "identifier", "id_businesspartner", "id_adminuser", "title", "dt_completion", "dt_make", "dt_paymentdeadline", "price_sum_net", "price_sum", "price_vat", "payment_type", "from_store", "to_store", "from_name", "from_taxnumber", "from_taxnumbercountrygroup", "from_taxnumberother", "from_registrationnumber", "from_bank_account", "from_zip", "from_public_space", "from_nature_of_public_space", "from_house_number", "from_building", "from_staircase", "from_floor", "from_door", "from_county", "from_city", "from_country", "from_phone_def", "from_email_def", "from_lot_number", "to_name", "to_taxnumber", "to_taxnumbercountrygroup", "to_taxnumberother", "to_registrationnumber", "to_bank_account", "to_zip", "to_public_space", "to_nature_of_public_space", "to_house_number", "to_building", "to_staircase", "to_floor", "to_door", "to_county", "to_city", "to_country", "to_phone_def", "to_email_def", "to_lot_number", "deleted"
              , "wf_status", "text", "text2", "price_sum_net_currency", "price_vat_currency", "price_sum_currency", "dt_transfer", "dt_needtransfer", "transfered", "currency", "navdata"]);
            const req = {};
            req.data = data;
            req.elements = modul.element;
            if (type) {
              req.type = type;
            }
            req.id_company = modul.state.id_company;

            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";

            Api.saveInvoiceInbound(req).then(function (res) {
              if (res && res.result && res.data && res.data.id) {
                modul.data.id = res.data.id;
                if (modul.data.id) {
                  const id = res.data.id;
                  setTimeout(function (e) {
                    modul.$router.push({
                      path: '/emptypage'
                    });
                    setTimeout(function (e) {
                      modul.$router.push({
                        path: '/invoiceinbound/' + id
//                    name: "storevenue", params: {id: modul.data.id}
                      });
                    }, 10);
                  }, 300);
                }
                if (res && res.resultFinalize) {
                  modul.data.definitive = 1;
                  modul.viewRole = 0;
                }
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
              modul.AlertInPage.msg = "";
            }, function (e) {
              modul.AlertInPage.msg = "";

            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        });
      }

      ,
      copyBusinessDataToModel: function (direction) {
        const modul = this;
//        const businesspartner = Helper.getObjectByIdFromObjectArray(modul.businesspartners, modul.businesspartnerid);

        const businesspartnerdata = modul.businesspartnerdata;
        const moduldata = Object.assign({}, modul.data);
        if (businesspartnerdata && businesspartnerdata.id) {
          // ez itt azért lesz jó, mert ide nem is kerülhet, ha már a definitive === 1

          modul.data.id_businesspartner = businesspartnerdata.id;

          if (direction && direction === "from") {
            moduldata.from_name = modul.businesspartnerdata.businesspartnername;
//        moduldata.from_nameany = modul.businesspartnerdata.businesspartnernameany;
            moduldata.from_taxnumber = modul.businesspartnerdata.taxnumber;
            moduldata.from_taxnumbercountrygroup = modul.businesspartnerdata.taxnumbercountrygroup;
            moduldata.from_taxnumberother = modul.businesspartnerdata.taxnumberother;
            moduldata.from_registrationnumber = modul.businesspartnerdata.registrationnumber;
            moduldata.from_bank_account = modul.businesspartnerdata.bank_account;
            moduldata.from_zip = modul.businesspartnerdata.zip;
            moduldata.from_public_space = modul.businesspartnerdata.public_space;
            moduldata.from_nature_of_public_space = modul.businesspartnerdata.nature_of_public_space;
            moduldata.from_house_number = modul.businesspartnerdata.house_number;
            moduldata.from_building = modul.businesspartnerdata.building;
            moduldata.from_staircase = modul.businesspartnerdata.staircase;
            moduldata.from_floor = modul.businesspartnerdata.floor;
            moduldata.from_door = modul.businesspartnerdata.door;
            moduldata.from_county = modul.businesspartnerdata.county;
            moduldata.from_city = modul.businesspartnerdata.city;
            moduldata.from_country = modul.businesspartnerdata.country;
            moduldata.from_email_def = modul.businesspartnerdata.email_def;
            moduldata.from_phone_def = modul.businesspartnerdata.phone_def;
            moduldata.from_lot_number = modul.businesspartnerdata.lot_number;
          } else if (direction && direction === "to") {
            moduldata.to_name = businesspartnerdata.businesspartnername;
//          moduldata.to_nameany = businesspartnerdata.businesspartnernameany;
            moduldata.to_taxnumber = businesspartnerdata.taxnumber;
            moduldata.to_taxnumbercountrygroup = businesspartnerdata.taxnumbercountrygroup;
            moduldata.to_taxnumberother = businesspartnerdata.taxnumberother;
            moduldata.to_registrationnumber = businesspartnerdata.registrationnumber;
            moduldata.to_bank_account = businesspartnerdata.bank_account;
            moduldata.to_zip = businesspartnerdata.zip;
            moduldata.to_public_space = businesspartnerdata.public_space;
            moduldata.to_nature_of_public_space = businesspartnerdata.nature_of_public_space;
            moduldata.to_house_number = businesspartnerdata.house_number;
            moduldata.to_building = businesspartnerdata.building;
            moduldata.to_staircase = businesspartnerdata.staircase;
            moduldata.to_floor = businesspartnerdata.floor;
            moduldata.to_door = businesspartnerdata.door;
            moduldata.to_county = businesspartnerdata.county;
            moduldata.to_city = businesspartnerdata.city;
            moduldata.to_country = businesspartnerdata.country;
            moduldata.to_email_def = businesspartnerdata.email_def;
            moduldata.to_phone_def = businesspartnerdata.phone_def;
            moduldata.to_lot_number = businesspartnerdata.lot_number;
          }
          modul.data = Object.assign({}, moduldata);
        }
      }
      ,
      copyCompanyDataToModel: function () {
        const modul = this;
//                modul.fillCompanydata();
        modul.data.to_name = modul.companydata.companyname;
//        modul.data.to_nameany = modul.companydata.companynameany;
        modul.data.to_name = modul.companydata.name;
        modul.data.to_taxnumber = modul.companydata.taxnumber;
        modul.data.to_taxnumbercountrygroup = modul.companydata.taxnumbercountrygroup;
        modul.data.to_taxnumberother = modul.companydata.taxnumberother;
        modul.data.to_registrationnumber = modul.companydata.registrationnumber;
        modul.data.to_bank_account = modul.companydata.bank_account;
        modul.data.to_zip = modul.companydata.zip;
        modul.data.to_public_space = modul.companydata.public_space;
        modul.data.to_nature_of_public_space = modul.companydata.nature_of_public_space;
        modul.data.to_house_number = modul.companydata.house_number;
        modul.data.to_building = modul.companydata.building;
        modul.data.to_staircase = modul.companydata.staircase;
        modul.data.to_floor = modul.companydata.floor;
        modul.data.to_door = modul.companydata.door;
        modul.data.to_county = modul.companydata.county;
        modul.data.to_city = modul.companydata.city;
        modul.data.to_country = modul.companydata.country;
        modul.data.to_email_def = modul.companydata.email_def;
        modul.data.to_phone_def = modul.companydata.phone_def;
        modul.data.to_lot_number = modul.companydata.lot_number;
//        modul.data = Object.assign({}, modul.data); // nem kell mert végtelen ciklus
      }
//      ,
//      blockdelrow(type, index)
//      {
//        const modul = this;
//        let key = modul[type + "Keys"][index];
//        delete (modul[type][key]);
//        modul[type + "Keys"].splice(index, 1);
//        modul[type] = Object.assign({}, modul[type]);
//      }
//      ,
//      blockdown(type, index)
//      {
//        const modul = this;
//        // saját index beszedése
//        const ownIndex = index;
//        // megnézni van-e egyel nagyobb
//        if (typeof (modul[type + "Keys"][ownIndex + 1]) !== "undefined") {
//          // ha igen, csere
//          const key1 = modul[type + "Keys"][ownIndex];
//          const key2 = modul[type + "Keys"][ownIndex + 1];
//          const tempContainer = modul[type][key2];
//          modul[type][key2] = modul[type][key1];
//          modul[type][key1] = tempContainer;
//        }
//        modul[type] = Object.assign({}, modul[type]);
//      }
//      ,
//      blockup(type, index)
//      {
//        const modul = this;
//        // saját index beszedése
//        const ownIndex = index;
//        // megnézni van-e egyel nagyobb
//        if (typeof (modul[type + "Keys"][ownIndex - 1]) !== "undefined") {
//          // ha igen, csere
//          const key1 = modul[type + "Keys"][ownIndex];
//          const key2 = modul[type + "Keys"][ownIndex - 1];
//          const tempContainer = modul[type][key2];
//          modul[type][key2] = modul[type][key1];
//          modul[type][key1] = tempContainer;
//        }
//        modul[type] = Object.assign({}, modul[type]);
//      }
//      ,
//      blockaddrow(type, defObj)
//      {
//
//        const dataRowObject = {
//          "id": "",
//          "item_id_vat": "",
//          "item_element_name": "",
//          "item_vatpercent": "",
//          "item_pack": "",
//          "item_key": "",
//          "item_price": "",
//          "item_countnum": "",
//          "item_sumprice": "",
//          "rowtype": 0,
//          "deleted": "0"
//        };
//        if (defObj) {
//          dataRowObject["id"] = (defObj["id"]) ? defObj["id"] : "";
//          dataRowObject["item_element_name"] = (defObj["item_element_name"]) ? defObj["item_element_name"] : "";
//          dataRowObject["item_id_vat"] = (defObj["id_vat"]) ? Number(defObj["id_vat"]) : "";
////          dataRowObject["item_vatpercent"] = (defObj["item_vatpercent"]) ? Number(defObj["item_vatpercent"]):"";
//          dataRowObject["item_pack"] = (defObj["item_pack"]) ? defObj["item_pack"] : "";
//          dataRowObject["item_key"] = (defObj["item_key"]) ? defObj["item_key"] : "";
//          dataRowObject["item_price"] = (defObj["item_price"]) ? Helper.getFormattedPrice(defObj["item_price"]) : "";
//          dataRowObject["item_countnum"] = (defObj["item_countnum"]) ? defObj["item_countnum"] : "";
//          dataRowObject["item_sumprice"] = (defObj["item_sumprice"]) ? Helper.getFormattedPrice(defObj["item_sumprice"]) : "";
//          dataRowObject["rowtype"] = (defObj["rowtype"]) ? defObj["rowtype"] : 0;
//        }
//        const modul = this;
////        log.info("1111111111111");
//        let lengthIndex = modul[type + "Keys"].length; // last element index
//        let newRowName = "row0";
//        if (lengthIndex !== 0) {
//          let lastElement = modul[type + "Keys"][lengthIndex - 1]; // last element
//          let lastElementWithoutrow = lastElement.replace(/row/g, ''); // row szöveg leszedés
//          let lastElementnumberkey = Number(lastElementWithoutrow); // maradék szöveg számmá
//          newRowName = "row" + (lastElementnumberkey + 1);
//        }
//        modul[type][newRowName] = dataRowObject;
//        modul[type] = Object.assign({}, modul[type]);
//        modul[type + "Keys"].push(newRowName);
////                modul.fnFillEmptyPrices();
////                modul.fnCountSumPrices();
//      }
//      ,
//      getVats: function (cb, id) {
//        const cb2 = function (err, res) {
//          Array.prototype.forEach.call(res, function (e, x) {
//            e.cardinality = Number(e.cardinality);
//          });
//          cb(err, res);
//        };
////        window.db.select(
////          function (err, res) {
////            cb2(err, window.db.convertResToArray(err, res))
////          }
////          , "vat", "*", "(`deleted` = 0 OR `deleted` = '0')"); // , "(`deleted` = 0 OR `deleted` = '0')"
//      }
//      ,
//      getVatCardinalityByIdVat: function (id) {
//        const modul = this;
//        let ret = 0;
//        Array.prototype.forEach.call(modul.vats, function (e, x) {
//          if (Number(e.id) === Number(id)) {
//            ret = e.cardinality;
//          }
//          e.cardinality = Number(e.cardinality);
//        });
//        return ret
//      }
//      ,
//      fnFillEmptyPrices: function (e, x) {
//        const modul = this;
//        for (let rowIndex in modul.element) {
//          if (!modul.element.hasOwnProperty(rowIndex)) {
//            continue;
//          }
//          if (Number(modul.element[rowIndex].rowtype) !== 0) {
//            continue;
//          }
//          if (Number(modul.element[rowIndex].deleted) !== 0) {
//            continue;
//          }
//          if ((modul.element[rowIndex].item_price !== "-" ) && ( typeof(modul.element[rowIndex].item_price) === "undefined" || isNaN(Number(modul.element[rowIndex].item_price)))) {
//            modul.element[rowIndex].item_price = "" + 0;
//
//          }
//          if ((modul.element[rowIndex].item_price_net !== "-" ) && ( typeof(modul.element[rowIndex].item_price_net) === "undefined" || isNaN(Number(modul.element[rowIndex].item_price_net)))) {
//            modul.element[rowIndex].item_price_net = "" + 0;
//          }
//          if ((modul.element[rowIndex].item_countnum !== "-" ) && ( typeof(modul.element[rowIndex].item_countnum) === "undefined" || isNaN(Number(modul.element[rowIndex].item_countnum)))) {
//            modul.element[rowIndex].item_countnum = "" + 0;
//          }
//          const item_vatpercent = modul.getVatCardinalityByIdVat(modul.element[rowIndex].item_id_vat)
////            (modul.element[rowIndex].item_vatpercent) ? modul.element[rowIndex].item_vatpercent : 0;
////                    if (!modul.element[i].item_price_vat || isNaN(Number(modul.element[i].item_price_vat))){
////                        modul.element[i].item_price_vat=""+0;
////                    }
//          // Ez csak akkor dolgozik, ha mindkét ár 0
//          if (
//            Number(modul.element[rowIndex].item_price) === 0
//            && Number(modul.element[rowIndex].item_price_net) === 0
////                        && Number(modul.element[rowIndex].item_countnum) === 0
//          ) {
//            modul.element[rowIndex].item_price_vat = "0";
//            modul.element[rowIndex].item_sumprice = "0";
//          }
//          // Ezek csak akkor dolgoznak, ha az egyik field kitöltetlen
//          if (Number(modul.element[rowIndex].item_price) !== 0 && modul.element[rowIndex].item_price !== "-" && (isNaN(Number(modul.element[rowIndex].item_price_net)) || Number(modul.element[rowIndex].item_price_net) === 0  )) {
//            let item_price_net = Number(modul.element[rowIndex].item_price) / ((  Number(item_vatpercent) / 100 ) + 1);
//            modul.element[rowIndex].item_price_net = "" + Helper.getFormattedPrice(item_price_net);
//            modul.element[rowIndex].item_price_vat = "" + Helper.getFormattedPrice((Number(modul.element[rowIndex].item_price) - Number(item_price_net) ) * Number(modul.element[rowIndex].item_countnum)) + "";
//          }
//          if ((isNaN(Number(modul.element[rowIndex].item_price)) || Number(modul.element[rowIndex].item_price) === 0) && Number(modul.element[rowIndex].item_price_net) !== 0 && modul.element[rowIndex].item_price_net !== "-") {
//            let item_price = Number(modul.element[rowIndex].item_price_net) * ((  Number(item_vatpercent) / 100 ) + 1);
//            modul.element[rowIndex].item_price = "" + Helper.getFormattedPrice(item_price);
//            modul.element[rowIndex].item_price_vat = "" + Helper.getFormattedPrice((Number(item_price) - Number(modul.element[rowIndex].item_price_net) ) * Number(modul.element[rowIndex].item_countnum)) + "";
//          }
//
//        }
//        // ez loop-ot okozott. a random meg nem mehet oda, mert a key lesz..
////                modul.element=Object.assign({random:Math.random()},modul.element);
//        modul.fnCountSumPrices()
//
//      }
//      ,
//      fnMakeDiscountRows: function () {
//        const modul = this;
////                discountsKeys
////                discounts
////                const actualVats = [];
////                const actualVatElements = [];
//
//        const discountsKeys = [];
//        const discounts = {};
//        for (let rowIndex in modul.element) {
//          if (!modul.element.hasOwnProperty(rowIndex)) {
//            continue;
//          }
//          if (Number(modul.element[rowIndex].rowtype) !== 0) {
//            continue;
//          }
//          if (Number(modul.element[rowIndex].deleted) !== 0) {
//            continue;
//          }
//          const elementActualRow = modul.element[rowIndex];
//          // ha van ilyen sor,
//          const actualVatKey = "vat" + modul.getVatCardinalityByIdVat(modul.element[rowIndex].item_id_vat); //modul.element[rowIndex].item_vatpercent;
//          if (discountsKeys.indexOf(actualVatKey) !== -1) {
//            // ha van
//            const element = Object.assign({}, discounts[actualVatKey]);
////                        elementActualRow.item_vatpercent = elementActualRow.item_vatpercent;
//            element.item_price = "" + Helper.getFormattedDiscount(Number(element.item_price) + Number(elementActualRow.item_price) * (Number(modul.data.discount) * 0.01));
//            element.item_price_net = "" + Helper.getFormattedDiscount(Number(element.item_price_net) + Number(elementActualRow.item_price_net) * (Number(modul.data.discount) * 0.01));
//            element.item_price_vat = "" + Helper.getFormattedDiscount(Number(element.item_price_vat) + Number(elementActualRow.item_price_vat) * (Number(modul.data.discount) * 0.01));
//            element.item_sumprice = "" + Helper.getFormattedDiscount(Number(element.item_sumprice) + Number(elementActualRow.item_sumprice) * (Number(modul.data.discount) * 0.01));
//            element.deleted = "0";
//            element.rowtype = "1";
//            discounts[actualVatKey] = element;
//          } else {
//            // ha nincs
//            const element = {};
//            element.item_vatpercent = "" + modul.getVatCardinalityByIdVat(elementActualRow.item_id_vat); //Number(elementActualRow.item_vatpercent);
//            element.item_price = "" + Helper.getFormattedDiscount(Number(elementActualRow.item_price) * (Number(modul.data.discount) * 0.01));
//            element.item_price_net = "" + Helper.getFormattedDiscount(Number(elementActualRow.item_price_net) * (Number(modul.data.discount) * 0.01));
//            element.item_price_vat = "" + Helper.getFormattedDiscount(Number(elementActualRow.item_price_vat) * (Number(modul.data.discount) * 0.01));
//            element.item_sumprice = "" + Helper.getFormattedDiscount(Number(elementActualRow.item_sumprice) * (Number(modul.data.discount) * 0.01));
//            element.deleted = "0";
//            element.rowtype = "1";
//            discounts[actualVatKey] = element;
//          }
//          if (discountsKeys.indexOf(actualVatKey) === -1) {
//            discountsKeys.push(actualVatKey);
//          }
//        }
//        for (let rowIndex in discounts) {
//          if (!discounts.hasOwnProperty(rowIndex)) {
//            continue;
//          }
//          discounts[rowIndex].item_price = "-" + Number(discounts[rowIndex].item_price);
//          discounts[rowIndex].item_price_net = "-" + Number(discounts[rowIndex].item_price_net);
//          discounts[rowIndex].item_price_vat = "-" + Number(discounts[rowIndex].item_price_vat);
//          discounts[rowIndex].item_sumprice = "-" + Number(discounts[rowIndex].item_sumprice);
//        }
//        modul.discountsKeys = discountsKeys;
//        modul.discounts = discounts;
//
//        let discount_item_price = 0;
//        let discount_item_price_net = 0;
//        let discount_item_price_vat = 0;
//        let discount_item_sumprice = 0;
//
//        for (let rowIndexx in modul.discountsKeys) {
//          if (!modul.discountsKeys.hasOwnProperty(rowIndexx)) {
//            continue;
//          }
//          const rowIndexxKey = modul.discountsKeys[rowIndexx];
//
//          discount_item_price = discount_item_price + Number(modul.discounts[rowIndexxKey]['item_price']);
//          discount_item_price_net = discount_item_price_net + Number(modul.discounts[rowIndexxKey]['item_price_net']);
//          discount_item_price_vat = discount_item_price_vat + Number(modul.discounts[rowIndexxKey]['item_price_vat']);
//          discount_item_sumprice = discount_item_sumprice + Number(modul.discounts[rowIndexxKey]['item_sumprice']);
//        }
//        modul.discount_item_price = "" + discount_item_price;
//        modul.discount_item_price_net = "" + discount_item_price_net;
//        modul.discount_item_price_vat = "" + discount_item_price_vat;
//        modul.discount_item_sumprice = "" + discount_item_sumprice;
//      }
//      ,
//      fnCountSumPrices: function () {
//        const modul = this;
//        let price_sum_net = 0;
//        let price_vat = 0;
//        let price_sum = 0;
//        for (let i in modul.element) {
//          if (!modul.element.hasOwnProperty(i)) {
//            continue;
//          }
//          if (Number(modul.element[i].rowtype) === 0 && Number(modul.element[i].deleted) === 0) {
//            price_sum_net += Number(modul.element[i].item_price_net) * Number(modul.element[i].item_countnum);
//            price_vat += Number(modul.element[i].item_price_vat);
//            price_sum += Number(modul.element[i].item_sumprice);
//          } else if (Number(modul.element[i].rowtype) === 1) {
//            // 4 sorral lejjebb kezelve
////                        price_sum_net -= Number(modul.element[i].item_price_net) * Number(modul.element[i].item_countnum);
////                        price_vat -= Number(modul.element[i].item_price_vat);
////                        price_sum -= Number(modul.element[i].item_sumprice);
//          }
//        }
//        modul.fnMakeDiscountRows();
//
//        price_sum_net = price_sum_net + Number(modul.discount_item_price_net);
//        price_vat = price_vat + Number(modul.discount_item_price_vat);
//        price_sum = price_sum + Number(modul.discount_item_sumprice);
//
//        modul.data.price_sum_net = "" + Helper.getFormattedSumprice(price_sum_net);
//        modul.data.price_vat = "" + Helper.getFormattedSumprice(price_vat);
//        modul.data.price_sum = "" + Helper.getFormattedSumprice(price_sum);
//        modul.docDefinition = modul.makeDocDefinition();
//      }
//      ,
//      fnKey: function (e, x) {
//        const modul = this;
//        const arrProp = e.target.dataset.props.split("|");
//        const rowIndex = arrProp[0];
//        const rowField = arrProp[1];
//        const item_vatpercent = modul.getVatCardinalityByIdVat(modul.element[rowIndex].item_id_vat); //(modul.element[rowIndex].item_vatpercent) ? modul.element[rowIndex].item_vatpercent : 0;
//        // először kiszámítjuk az item price-ot, aztán abból számítunk darabszámos SUM értékeket, majd azt osztjuk vissza, és a végén kerekítjük az értékeket.
//        const item_countnum = Number(modul.element[rowIndex].item_countnum)
//        let item_price = Helper.getFormattedPrice(Number(modul.element[rowIndex].item_price));
//        if (rowField === "item_price_net" || modul.base_item === "net") {
//          item_price = Helper.getFormattedPrice(Number(modul.element[rowIndex].item_price_net) * ((  Number(item_vatpercent) / 100 ) + 1));
//        }
//        const item_price_sum = item_price * item_countnum;
//        const item_price_net_sum = item_price_sum / ((  Number(item_vatpercent) / 100 ) + 1);
//        const item_price_vat_sum = item_price_sum - item_price_net_sum;
//
//        const item_price_vat = item_price_vat_sum / item_countnum;
//        const item_price_net = item_price_net_sum / item_countnum;
//
//        modul.element[rowIndex].item_price = Helper.getFormattedPrice(item_price);
//        modul.element[rowIndex].item_price_net = Helper.getFormattedPrice(item_price_net);
//        modul.element[rowIndex].item_price_vat = Helper.getFormattedPrice(item_price_vat_sum);
//
//        modul.fnFillEmptyPrices();
////                if (rowField === "item_vatpercent") {
////                    modul.element[rowIndex].item_price_vat = "" + Helper.getFormattedPrice((Number(modul.element[rowIndex].item_price) - Number(item_price_net) ) * Number(modul.element[rowIndex].item_countnum)) + "";
////                }
//        modul.element[rowIndex].item_sumprice = "" + Helper.getFormattedPrice(Number(modul.element[rowIndex].item_price) * Number(modul.element[rowIndex].item_countnum)) + "";
//
////                modul.fnFillEmptyPrices();
//        modul.fnCountSumPrices();
//        modul.element = Object.assign({}, modul.element);
//        /*
//         item_vatpercent
//         item_price_net
//         item_price
//         item_countnum
//         */
//      }
//      ,
//      fnKeydow: function (e, x) {
////                const modul = this;
////                log.info("fnKeydow");
////                window.setTimeout(function () {
////                    modul.fnKey(e, x);
////                }, 100);
//      }
//      ,
//      fnKeyup: function (e, x) {
//        const modul = this;
////                log.info("fnKeyup");
//        window.setTimeout(function () {
//          modul.fnKey(e, x);
//        }, 100);
//      }
//      ,
//      errorMaker: function (e) {
//        const modul = this;
////        console.log("errorMaker");
////        console.log(e);
//        let ret = false;
//        if (!e) {
//          ret = Math.random()
//        }
//        return ret;
//      }
//      ,

//      , modal: function (e) {
//        const modul = this;
//        modul.$eventBus.$emit('modal', {
//          type: "confirm",
//          msgTitle: "",
//          tmsgTitle: "question",
//          msgText: "",
//          tmsgText: "areyousuresave",
//          fnCancel: function () {
//            console.log('fnCancel')
//          },
//          fnConfirm: function () {
//            console.log('fnConfirm')
//          }
//        });
//
//      }

    },
    components: {
      LeftMenu,
      NavDataDiffDisplayer,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      BarcodeGenerator,
      InputText,
      FileUploader,
      ImageDisplayer,
      MenuToggle,
      ElementSearcher,
      BusinessPartnerSearcher,
      PdfMake
    }
    ,
  }
  ;
</script>
<style>
  .input-group .d-block.w100 input {
    width: 100%;
  }

  .form-control.w100 {
    width: 100%;
  }

  .buttonsContainer {
    width: 122px;
  }

  .mw80 {
    min-width: 80px;
  }

  .h100 {
    height: 100px;
  }

  .overflow-hidden {
    overflow: hidden;
  }
</style>



